/** This component is to track the ticket and to view the details of a specific ticket*/

import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import { Send, ArrowLeft, MessageSquareWarning } from "lucide-react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../GisincidentManagement/ViewIncident/ViewIncident.css";
import {
  getThemeURL,
  grievanceClosed,
  grievanceInprogress,
  grievanceRejected,
  grievanceResolved,
  getUsersFromAppByRole,
  commentingForAdmins,
  manualEscalateL1,
  manualEscalateL2,
  manualEscalateL3,
  getDepartmentsCurrent,
  getUsersByUserLevelExceptCurrent,
  getBranchUserList,
  getAllPriority,
  createCrossDepartment,
  notificationRead,
  getNotificationsList,
  fetchGrievanceData,
  getHolidayList,
  getAvatarDetails,
  grievancePendingUser,
  grievancePendingExternal,
  reopenAfterClosed,
  getAllSLA,
} from "../../../Services/EndPoints";
import { getData } from "../../../Services/ProfileServices";
import { FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  postDataWithBody,
  postDataWithFiles,
} from "../../../Services/Services";
import { Modal, Button } from 'react-bootstrap';
import "./RaiseTicket.css";
import { LayoutState } from "../../../Context/LayoutContext/LayoutContext";
import Loader from "react-spinner-loader";

// Add this component inside your ViewRaisedTicket component file
const ReopenModal = ({
  show,
  onClose,
  ticketData,
  userId,
  onReopen,
  reopenRemarks,
  setReopenRemarks,
  reopenFiles,
  setReopenFiles,
  reopenToUserId,
  setReopenToUserId,
  isSubmitting,
  userProfile,
  l1Users
}) => {
   console.log("ReopenModal rendered, show:", show);
  if (!show) return null;

  const handleFileChange = (e) => {
  const files = Array.from(e.target.files);
  const maxFiles = 5;
  const maxSize = 1 * 1024 * 1024; // 1MB

  const allowedTypes = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/gif",
    "application/pdf",
  ];

  let newFiles = [];

  for (let file of files) {
    if (reopenFiles.length + newFiles.length >= maxFiles) {
      toast.error(`Maximum ${maxFiles} files allowed`);
      break;
    }

    if (file.size > maxSize) {
      toast.error(`"${file.name}" exceeds 1MB limit`);
      continue;
    }

    if (!allowedTypes.includes(file.type)) {
      toast.error(`"${file.name}" has unsupported file type`);
      continue;
    }

    newFiles.push({
      id: `${file.name}-${Date.now()}`,
      file,
      name: file.name,
      size: file.size,
      type: file.type,
    });
  }

  if (newFiles.length > 0) {
    setReopenFiles((prev) => [...prev, ...newFiles]);
  }

  e.target.value = "";
};

  
  const removeFile = (fileId) => {
    setReopenFiles(prev => prev.filter(file => file.id !== fileId));
  };
  
  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };
  
  const getCurrentDateTime = () => {
    const now = new Date();
    const formatDateTimeForAPI = (date) => {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();
      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;
      const formattedHours = String(hours).padStart(2, "0");
      return `${dd}-${mm}-${yyyy} ${formattedHours}:${minutes} ${ampm}`;
    };
    return formatDateTimeForAPI(now);
  };

  return (
    <div
      className="modal"
      style={{
        display: "block",
        position: "fixed",
        zIndex: 1060,
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        overflow: "auto",
        backgroundColor: "rgba(0,0,0,0.4)",
      }}
      onClick={onClose}
    >
      <div
        className="modal-dialog"
        style={{
          position: "relative",
          width: "auto",
          margin: "1.75rem auto",
          maxWidth: "600px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="modal-content"
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            width: "100%",
            backgroundColor: "#fff",
            backgroundClip: "padding-box",
            border: "1px solid rgba(0,0,0,.2)",
            borderRadius: "0.3rem",
            boxShadow: "0 0.25rem 0.5rem rgba(0,0,0,.5)",
          }}
        >
          {/* Header */}
          <div
            className="modal-header"
            style={{
              borderBottom: "1px solid #e5e5e5",
              padding: "12px 20px",
              backgroundColor: "#f9fafb",
              borderTopLeftRadius: "0.3rem",
              borderTopRightRadius: "0.3rem",
            }}
          >
            <h5
              style={{
                fontSize: "15px",
                fontWeight: "600",
                color: "#222",
                margin: 0,
                fontFamily: "Poppins",
              }}
            >
              Reopen Ticket – {ticketData?.id}
            </h5>
            <button
              onClick={onClose}
              style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                color: "#555",
                cursor: "pointer",
                lineHeight: 1,
              }}
            >
              ×
            </button>
          </div>

          {/* Body */}
          <div
            className="modal-body"
            style={{
              padding: "20px",
              fontSize: "14px",
              color: "#333",
              fontFamily: "Poppins",
              maxHeight: "70vh",
              overflowY: "auto",
            }}
          >
            {/* Ticket Info */}
            {[
              ["Ticket ID", ticketData?.id],
              ["Category", ticketData?.type || "Software"],
            ].map(([label, value]) => (
              <div key={label} style={{ marginBottom: "10px" }}>
                <label
                  style={{
                    display: "block",
                    fontWeight: "600",
                    marginBottom: "3px",
                    color: "#111",
                    fontSize: "13px",
                  }}
                >
                  {label}
                </label>
                <input
                  type="text"
                  value={value}
                  readOnly
                  style={{
                    width: "100%",
                    border: "1px solid #dee2e6",
                    borderRadius: "6px",
                    padding: "6px 10px",
                    backgroundColor: "#f8f9fa",
                    fontSize: "13px",
                    color: "#333",
                    fontWeight: "500",
                    fontFamily: "Poppins",
                  }}
                />
              </div>
            ))}

            <hr style={{ margin: "16px 0" }} />

            {/* File Upload Section */}
            <div style={{ marginBottom: "14px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "6px",
                }}
              >
                <label
                  style={{
                    fontWeight: "600",
                    fontSize: "13px",
                    color: "#333",
                  }}
                >
                  Attach Evidence / Screenshots
                </label>
                {reopenFiles.length > 0 && (
                  <button
                    onClick={() => setReopenFiles([])}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#ff4444",
                      fontSize: "11px",
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontFamily: "Poppins",
                    }}
                  >
                    Clear All
                  </button>
                )}
              </div>

              {/* Upload Area */}
              <div
                style={{
                  border: "2px dashed #2E6DA4",
                  borderRadius: "8px",
                  padding: "20px",
                  textAlign: "center",
                  backgroundColor: "#f8fbfc",
                  cursor: "pointer",
                  position: "relative",
                  transition: "all 0.3s ease",
                  marginBottom: "12px",
                }}
              >
                <input
                  type="file"
                  multiple
                  accept="image/*,.png,.jpg,.jpeg,.pdf,.gif"
                  onChange={handleFileChange}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    opacity: 0,
                    cursor: "pointer",
                  }}
                />
                <div
                  style={{
                    fontSize: "13px",
                    color: "#666",
                    marginBottom: "8px",
                  }}
                >
                  <div style={{ fontSize: "24px", marginBottom: "8px" }}>
                    📁
                  </div>
                  <div
                    style={{
                      fontWeight: "600",
                      color: "#2E6DA4",
                      marginBottom: "4px",
                    }}
                  >
                    Click to upload or drag and drop
                  </div>
                  <div style={{ fontSize: "12px", color: "#888" }}>
                    Supports: PNG, JPG, JPEG, GIF, PDF (Max: 1MB per file, Max 5 files total)
                  </div>
                </div>
              </div>

              {/* File Preview */}
              {reopenFiles.length > 0 && (
                <div
                  style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "6px",
                    padding: "12px",
                    backgroundColor: "#f9f9f9",
                    marginBottom: "8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "8px",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: "600",
                        fontSize: "13px",
                        color: "#333",
                      }}
                    >
                      Selected Files ({reopenFiles.length})
                    </span>
                    <div style={{ fontSize: "11px", color: "#666" }}>
                      Total:{" "}
                      {formatFileSize(
                        reopenFiles.reduce((acc, file) => acc + file.size, 0)
                      )}
                    </div>
                  </div>

                  <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                    {reopenFiles.map((fileObj) => (
                      <div
                        key={fileObj.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          padding: "8px",
                          backgroundColor: "white",
                          borderRadius: "4px",
                          border: "1px solid #e8e8e8",
                          marginBottom: "6px",
                        }}
                      >
                        <div
                          style={{
                            width: "32px",
                            height: "32px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#2E6DA4",
                            borderRadius: "4px",
                            color: "white",
                            flexShrink: 0,
                          }}
                        >
                          {fileObj.type.includes("image") ? (
                            <i className="bi bi-image"></i>
                          ) : fileObj.type.includes("pdf") ? (
                            <i className="bi bi-file-earmark-pdf"></i>
                          ) : (
                            <i className="bi bi-file-earmark"></i>
                          )}
                        </div>

                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div
                            style={{
                              fontWeight: "500",
                              fontSize: "12px",
                              color: "#333",
                              marginBottom: "2px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                            title={fileObj.name}
                          >
                            {fileObj.name}
                          </div>
                          <div
                            style={{
                              fontSize: "10px",
                              color: "#666",
                            }}
                          >
                            {formatFileSize(fileObj.size)} •{" "}
                            {fileObj.type.split("/")[1]?.toUpperCase() || "FILE"}
                          </div>
                        </div>

                        <button
                          onClick={() => removeFile(fileObj.id)}
                          style={{
                            background: "none",
                            border: "none",
                            color: "#ff4444",
                            cursor: "pointer",
                            padding: "4px",
                            borderRadius: "3px",
                            flexShrink: 0,
                          }}
                          title="Remove file"
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Remarks */}
            <div style={{ marginBottom: "10px" }}>
              <label
                style={{
                  display: "block",
                  fontWeight: "600",
                  marginBottom: "3px",
                  color: "#111",
                  fontSize: "13px",
                }}
              >
                Reason for Reopening
                <span style={{ color: "red" }}> *</span>
              </label>

              <textarea
                value={reopenRemarks}
                onChange={(e) => setReopenRemarks(e.target.value)}
                placeholder="Enter detailed reason for reopening this ticket..."
                style={{
                  width: "100%",
                  border: reopenRemarks.length > 750 ? "1px solid #dc3545" : "1px solid #ced4da",
                  borderRadius: "6px",
                  padding: "8px 10px",
                  fontSize: "13px",
                  fontWeight: "500",
                  resize: "vertical",
                  minHeight: "80px",
                  fontFamily: "Poppins",
                }}
              />

              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "4px",
              }}>
                <div style={{
                  fontSize: "11px",
                  color: reopenRemarks.length > 750 ? "#dc3545" : "#666",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}>
                 Please specify the reason to reopen
                </div>

                <div style={{
                  fontSize: "11px",
                  color: reopenRemarks.length > 750 ? "#dc3545" :
                    reopenRemarks.length >= 700 ? "#6c757d" : "#666",
                  fontWeight: reopenRemarks.length > 750 ? "600" : "normal",
                }}>
                  {reopenRemarks.length}/750 characters
                  {reopenRemarks.length >= 751 && (
                    <span style={{ marginLeft: "4px", color: "#dc3545" }}>
                      <i className="bi bi-exclamation-triangle"></i> Character limit reached
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Requested By */}
            <div style={{ marginBottom: "10px" }}>
              <label
                style={{
                  display: "block",
                  fontWeight: "600",
                  marginBottom: "3px",
                  color: "#111",
                  fontSize: "13px",
                }}
              >
                Requested By
              </label>
              <input
                type="text"
                value={
                  userProfile?.first_name && userProfile?.last_name
                    ? `${userProfile.first_name} ${userProfile.last_name}`
                    : userProfile?.first_name ||
                      userProfile?.user_name ||
                      "N/A"
                }
                readOnly
                style={{
                  width: "100%",
                  border: "1px solid #dee2e6",
                  borderRadius: "6px",
                  padding: "6px 10px",
                  backgroundColor: "#f8f9fa",
                  fontSize: "13px",
                  fontFamily: "Poppins",
                }}
              />
            </div>

            {/* Date and Time */}
            <div style={{ marginBottom: "10px" }}>
              <label
                style={{
                  display: "block",
                  fontWeight: "600",
                  marginBottom: "3px",
                  color: "#111",
                  fontSize: "13px",
                }}
              >
                Date and Time of reopen request
              </label>
              <input
                type="text"
                value={getCurrentDateTime()}
                readOnly
                style={{
                  width: "100%",
                  border: "1px solid #dee2e6",
                  borderRadius: "6px",
                  padding: "6px 10px",
                  backgroundColor: "#f8f9fa",
                  fontSize: "13px",
                  fontFamily: "Poppins",
                }}
              />
            </div>
          </div>

          {/* Footer */}
          <div
            className="modal-footer"
            style={{
              borderTop: "1px solid #e5e5e5",
              backgroundColor: "#f9fafb",
              padding: "12px 20px",
              display: "flex",
              justifyContent: "flex-end",
              gap: "8px",
              borderBottomRightRadius: "0.3rem",
              borderBottomLeftRadius: "0.3rem",
            }}
          >
            <button
              onClick={onClose}
              style={{
                backgroundColor: "#6c757d",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                padding: "6px 16px",
                fontSize: "13px",
                cursor: "pointer",
                fontFamily: "Poppins",
                fontWeight: "500",
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => onReopen({
                remarks: reopenRemarks,
                files: reopenFiles,
                reopenToUserId
              })}
              disabled={isSubmitting || !reopenRemarks.trim() || reopenRemarks.length > 750}
              style={{
                backgroundColor: !reopenRemarks.trim() || reopenRemarks.length > 750
                  ? "#ccc"
                  : "#2E6DA4",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                padding: "6px 16px",
                fontSize: "13px",
                cursor:
                  !reopenRemarks.trim() || isSubmitting || reopenRemarks.length > 750
                    ? "not-allowed"
                    : "pointer",
                fontFamily: "Poppins",
                fontWeight: "500",
                opacity: isSubmitting ? 0.6 : 1,
              }}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const ViewRaisedTicket = () => {
  const location = useLocation();
  const [showManualEscalationWarning, setShowManualEscalationWarning] = useState(true);
  const [isGrievanceInfoExpanded, setIsGrievanceInfoExpanded] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const { collapsed } = LayoutState();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [reassignmentPrefix, setReassignmentPrefix] = useState("");
  const [l2AssignmentDescription, setL2AssignmentDescription] = useState('');
  const [assignmentDescription, setAssignmentDescription] = useState('');
  const [tempReassignDescription, setTempReassignDescription] = useState("");
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [reassignDescription, setReassignDescription] = useState('');
  const [reassignmentDescription, setReassignmentDescription] = useState('');
  const [reassignmentRequired, setReassignmentRequired] = useState(false);
  const [reassignmentError, setReassignmentError] = useState("");
  const [mediaList, setMediaList] = useState([]);
  const [comment, setComment] = useState("");
  const navigate = useNavigate();
  const [comments, setComments] = useState([]);
  const [userId, setUserId] = useState(null);
  const [user, setUser] = useState(null);
  const [statusError, setStatusError] = useState("");
  const [commentError, setCommentError] = useState("");
  const [UserList, setUserList] = useState([]);
  const [rootCauseError, setRootCauseError] = useState("");
  const [initialStatusOptions, setInitialStatusOptions] = useState([]);
  const [ticketData, setTicketData] = useState(
    () =>
      location.state?.data ||
      location.state?.eventData ||
      JSON.parse(sessionStorage.getItem("ticketData")) ||
      null
  );
  const [currentStatus, setCurrentStatus] = useState(
    ticketData?.status || "Open"
  );
  const isStatusClosedOrRejected =
    ticketData?.status === "Closed" || ticketData?.status === "Rejected";
  const hasActionMessage =
    // eslint-disable-next-line eqeqeq
    ticketData?.originalData?.grievanceTicketMapEntity?.status == 843 ||
    // eslint-disable-next-line eqeqeq
    ticketData?.originalData?.grievanceTicketMapEntity?.status == 844;
  const [fileErrors, setFileErrors] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const [isAdmin, setisAdmin] = useState(false);
  const [actionTaken, setActionTaken] = useState("");
  const [rootCause, setRootCause] = useState("");
  const [resolutionSteps, setResolutionSteps] = useState("");
  // Stores field values per status so switching back restores previous input
  const statusFieldSnapshot = React.useRef({});
  const [isRootCauseDisabled, setIsRootCauseDisabled] = useState(false);
  const [isActionTakenDisabled, setIsActionTakenDisabled] = useState(false);
  const [isResolutionStepsDisabled, setIsResolutionStepsDisabled] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isAdminCommenting, setIsAdminCommenting] = useState(false);
  const [userLevel, setUserLevel] = useState(null);
  const [escalationLevel, setEscalationLevel] = useState("");
  const [escalationUserId, setEscalationUserId] = useState(null);

  const [showEscalationModal, setShowEscalationModal] = useState(false);
  const [escalationComment, setEscalationComment] = useState('');
  const [escalationType, setEscalationType] = useState(() => {
    const hasManualEscalateRemarks1 = ticketData?.originalData?.escalateRemarks1 &&
                                      !ticketData?.originalData?.escalateRemarks1.toLowerCase().includes('auto-escalated');
    const hasManualEscalateRemarks2 = ticketData?.originalData?.escalateRemarks2 &&
                                      !ticketData?.originalData?.escalateRemarks2.toLowerCase().includes('auto-escalated');
    const hasManualEscalateRemarks3 = ticketData?.originalData?.escalateRemarks3 &&
                                      !ticketData?.originalData?.escalateRemarks3.toLowerCase().includes('auto-escalated');

    if (hasManualEscalateRemarks1 || hasManualEscalateRemarks2 || hasManualEscalateRemarks3) {
      return 'manual';
    }

    const autoEscalatedL1 = ticketData?.originalData?.escalateRemarks1?.toLowerCase().includes('auto-escalated');
    const autoEscalatedL2 = ticketData?.originalData?.escalateRemarks2?.toLowerCase().includes('auto-escalated');
    const autoEscalatedL3 = ticketData?.originalData?.escalateRemarks3?.toLowerCase().includes('auto-escalated');

    if (autoEscalatedL1 || autoEscalatedL2 || autoEscalatedL3) {
      return 'manual';
    }

    if (ticketData?.originalData?.slaBreached === true) {
      return 'manual';
    }

    return 'manual';
  });
  const [showCrossDepartmentModal, setShowCrossDepartmentModal] = useState(false);
  const [transferData, setTransferData] = useState({
    targetDepartment: '',
    transferReason: '',
    transferType: '',
    supportingRemarks: ''
  });
  const [crossDepartmentUserId, setCrossDepartmentUserId] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [departments, setDepartments] = useState([]);
  const [crossDepartmentLOUsers, setCrossDepartmentLOUsers] = useState([]);
  const [priorityTime, setPriorityTime] = useState(null);
  const [customPriority, setCustomPriority] = useState('');
  const [showTransferReasonModal, setShowTransferReasonModal] = useState(false);
  const [selectedTransferReason, setSelectedTransferReason] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [isSubmittingCrossDepartment, setIsSubmittingCrossDepartment] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [slaDeadlineError, setSlaDeadlineError] = useState("");
  const [holidays, setHolidays] = useState([]);
  const [isLoadingHolidays, setIsLoadingHolidays] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [supportAdmin, setSupportAdmin] = useState(null);
  const [tooltipData, setTooltipData] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [showReopenModal, setShowReopenModal] = useState(false);
  const [reopenRemarks, setReopenRemarks] = useState("");
  const [reopenFiles, setReopenFiles] = useState([]);
  const [reopenToUserId, setReopenToUserId] = useState("");
  const [isSubmittingReopen, setIsSubmittingReopen] = useState(false);
  const [priorities, setPriorities] = useState([]);
  console.log(supportAdmin, "supportAdminsupportAdminsupportAdminsupportAdmin");
  const [isSubmittingEscalation, setIsSubmittingEscalation] = useState(false);
  const tooltipRef = useRef(null);
  const [loader, setLoader] = useState(false);

  console.log(ticketData?.originalData?.crossDeptDisable, "ticketdata");
  console.log(ticketData, "ticketdata");
  console.log(
    userLevel,
    ticketData?.originalData?.userLevel,
    "userLeveluserLeveluserLeveluserLevel"
  );

  const isL1AndCreator = () => {
    return userLevel === "L1" && user === ticketData?.originalData?.createdBy;
  };

  useEffect(() => {
    const fetchPriorities = async () => {
      try {
        const response = await getData(getAllSLA);
        if (response && Array.isArray(response)) {
          setPriorities(response);
        }
      } catch (error) {
        console.error("Error fetching priorities:", error);
      }
    };

    fetchPriorities();
  }, []);

  const calculateSLADate = (priority, currentDate) => {
    if (!priority || !priorities || priorities.length === 0) {
      console.log("No priority or SLA data found, using default 2 hours");
      return new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);
    }

    const slaConfig = priorities.find(
      (sla) => sla.priority && sla.priority.toLowerCase() === priority.toLowerCase()
    );

    if (!slaConfig) {
      console.log("No SLA config found for priority:", priority, "using default 2 hours");
      return new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);
    }

    const { maxResTimeValue, maxResTimeType } = slaConfig;
    let targetDate = new Date(currentDate);

    if (holidays.length > 0 && !isLoadingHolidays) {
      switch (maxResTimeType?.toLowerCase()) {
        case "minutes":
          targetDate = addMinutesExcludingSundaysAndHolidays(currentDate, maxResTimeValue);
          break;
        case "hours":
          targetDate = addHoursExcludingSundaysAndHolidays(currentDate, maxResTimeValue);
          break;
        case "days":
          targetDate = addDaysExcludingSundaysAndHolidays(currentDate, maxResTimeValue);
          break;
        default:
          targetDate.setHours(targetDate.getHours() + 2);
      }
    } else {
      switch (maxResTimeType?.toLowerCase()) {
        case "minutes":
          targetDate.setMinutes(targetDate.getMinutes() + maxResTimeValue);
          break;
        case "hours":
          targetDate.setHours(targetDate.getHours() + maxResTimeValue);
          if (targetDate.getDay() === 0) {
            targetDate.setDate(targetDate.getDate() + 1);
          }
          break;
        case "days":
          targetDate = addDaysExcludingSundays(currentDate, maxResTimeValue);
          break;
        default:
          targetDate.setHours(targetDate.getHours() + 2);
      }
    }

    return targetDate;
  };

  const handleReopenSubmit = async ({ remarks, files, reopenToUserId }) => {
    if (!remarks.trim()) {
      toast.error("Please provide a reason for reopening");
      return;
    }

    if (remarks.length > 750) {
      toast.error("Reopening remarks cannot exceed 750 characters");
      return;
    }

    setIsSubmittingReopen(true);

    try {
      const formData = new FormData();
      const now = new Date();
      const reopenedDate = formatDateTimeForAPI(now);

      const priority = ticketData.criticality || ticketData.originalData?.priority;
      console.log(priority, "sla time check");

      const resSLADate = calculateSLADate(priority, now);
      const resSLADateString = formatDateTimeForAPI(resSLADate);

      const userLevelFromGrievance =
        ticketData.userLevels ||
        ticketData.originalData?.userLevel ||
        "L1";

      const reopenedToValue = reopenToUserId
        ? parseInt(reopenToUserId)
        : ticketData.originalData.createdBy;

      const grievanceData = {
        id: ticketData.originalData.id,
        reOpenedDateAndTimeString: reopenedDate,
        resSLADateAndTimeString: resSLADateString,
        reOpenedTo: reopenedToValue,
        reOpenedRemarks: remarks,
        userLevel: userLevelFromGrievance,
      };

      formData.append("grievance", JSON.stringify(grievanceData));

      if (files && files.length > 0) {
        files.forEach((fileObj) => {
          formData.append("files", fileObj.file);
        });
      } else {
        formData.append("files", new Blob(), "empty.txt");
      }

      const response = await postDataWithBody(reopenAfterClosed, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response && response.status === "success") {
        toast.success(`Ticket ${ticketData.id} reopened successfully`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });

        setShowReopenModal(false);
        setReopenRemarks("");
        setReopenFiles([]);
        setReopenToUserId("");

        navigate("../grievance");
      } else {
        throw new Error(response?.msg || "Failed to reopen ticket");
      }
    } catch (error) {
      console.error("Error reopening ticket:", error);
      toast.error(error.message || "Failed to reopen ticket", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    } finally {
      setIsSubmittingReopen(false);
    }
  };

  useEffect(() => {
    const hasManualEscalateRemarks1 = ticketData?.originalData?.escalateRemarks1 &&
                                      !ticketData?.originalData?.escalateRemarks1.toLowerCase().includes('auto-escalated');
    const hasManualEscalateRemarks2 = ticketData?.originalData?.escalateRemarks2 &&
                                      !ticketData?.originalData?.escalateRemarks2.toLowerCase().includes('auto-escalated');
    const hasManualEscalateRemarks3 = ticketData?.originalData?.escalateRemarks3 &&
                                      !ticketData?.originalData?.escalateRemarks3.toLowerCase().includes('auto-escalated');

    if (hasManualEscalateRemarks1 || hasManualEscalateRemarks2 || hasManualEscalateRemarks3) {
      setEscalationType('manual');
      setShowManualEscalationWarning(false);
      return;
    }

    const autoEscalatedL1 = ticketData?.originalData?.escalateRemarks1?.toLowerCase().includes('auto-escalated');
    const autoEscalatedL2 = ticketData?.originalData?.escalateRemarks2?.toLowerCase().includes('auto-escalated');
    const autoEscalatedL3 = ticketData?.originalData?.escalateRemarks3?.toLowerCase().includes('auto-escalated');

    if (autoEscalatedL1 || autoEscalatedL2 || autoEscalatedL3) {
      setEscalationType('manual');
      setShowManualEscalationWarning(true);
      return;
    }

    if (ticketData?.originalData?.slaBreached === true) {
      setEscalationType('manual');
      setShowManualEscalationWarning(true);
    }
  }, [
    ticketData?.originalData?.escalateRemarks1,
    ticketData?.originalData?.escalateRemarks2,
    ticketData?.originalData?.escalateRemarks3,
    ticketData?.originalData?.slaBreached
  ]);

  useEffect(() => {
    if (ticketData?.originalData?.grievanceReassignmentL1Entities &&
        ticketData.originalData.grievanceReassignmentL1Entities.length > 0 &&
        user) {
      const latestAssignment = ticketData.originalData.grievanceReassignmentL1Entities[0];
      if (latestAssignment.newL1User === user) {
        setAssignmentDescription(latestAssignment.reassignmentDescription || '');
      } else {
        setAssignmentDescription('');
      }
    } else {
      setAssignmentDescription('');
    }
  }, [ticketData?.originalData?.grievanceReassignmentL1Entities, user]);

  useEffect(() => {
    if (ticketData?.originalData?.grievanceReassignmentL2Entities &&
        ticketData.originalData.grievanceReassignmentL2Entities.length > 0 &&
        user) {
      const latestL2Assignment = ticketData.originalData.grievanceReassignmentL2Entities[0];
      if (latestL2Assignment.newL2User === user) {
        setL2AssignmentDescription(latestL2Assignment.reassignmentDescription || '');
      } else {
        setL2AssignmentDescription('');
      }
    } else {
      setL2AssignmentDescription('');
    }
  }, [ticketData?.originalData?.grievanceReassignmentL2Entities, user]);

  const handleAvatarInteraction = async (userData, event, action = 'click') => {
    if (!event || !event.currentTarget) {
      console.error("Event or currentTarget is null");
      return;
    }

    console.log("Clicked user data:", userData);

    const userId = userData.userId || userData?.value || user;

    if (!userId) {
      console.error("No user ID found in userData");
      const dummyUserData = {
        name: userData?.user || "User",
        email: "user@example.com",
        phone: "+1 234-567-8900",
        userId: "USR001",
        role: "Department Manager",
        department: "N/A",
        is_helpdesk: false
      };

      console.log("Setting tooltip data:", dummyUserData);
      setTooltipData(dummyUserData);
    } else {
      try {
        setTooltipData({
          name: userData?.user || "Loading...",
          email: "Loading...",
          phone: "Loading...",
          userId: userId,
          role: "Loading...",
          department: "Loading...",
          is_helpdesk: false
        });

        const payload = [parseInt(userId, 10)];

        console.log("Sending payload to getAvatarDetails:", payload);

        const response = await postDataWithBody(
          getAvatarDetails,
          payload,
          {}
        );

        console.log("User details API response:", response);

        if (response && Array.isArray(response) && response.length > 0) {
          const user = response[0];

          const name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
          let phone = user.phone_number || user.phone || user.mobile || "N/A";
          let email = user.email || "N/A";
          let extractedUserId = user.user_name || userId;
          let role = user.jobTitleName || "N/A";

          let is_helpdesk = false;
          let department = "N/A";
          if (user.user_department_map && user.user_department_map.length > 0) {
            const deptEntity = user.user_department_map[0].departmentEntity;
            if (deptEntity) {
              department = deptEntity.name || "N/A";
              is_helpdesk = deptEntity.is_helpdesk === true;
            }
          }

          const userDetails = {
            name: name,
            email: email,
            phone: phone,
            userId: extractedUserId,
            role: role,
            department: department,
            is_helpdesk: is_helpdesk
          };

          console.log("Setting tooltip data from API:", userDetails);
          setTooltipData(userDetails);

        } else {
          const fallbackData = {
            name: userData?.user || "User",
            email: "N/A",
            phone: "N/A",
            userId: userId,
            role: "Department Manager",
            department: "N/A",
            is_helpdesk: false
          };
          setTooltipData(fallbackData);
        }

      } catch (error) {
        console.error("Error fetching user details:", error);
        const fallbackData = {
          name: userData?.user || "User",
          email: "N/A",
          phone: "N/A",
          userId: userId,
          role: "Department Manager",
          department: "N/A",
          is_helpdesk: false
        };
        setTooltipData(fallbackData);

        toast.error("Failed to fetch user details", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    }

    try {
      const rect = event.currentTarget.getBoundingClientRect();
      setTooltipPosition({
        x: rect.left + window.scrollX,
        y: rect.top + window.scrollY,
      });
    } catch (error) {
      console.error("Error getting element position:", error);
      setTooltipPosition({
        x: 100,
        y: 100,
      });
    }

    setShowTooltip(true);
  };

  const closeTooltip = () => {
    setShowTooltip(false);
    setTooltipData(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        closeTooltip();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const UserTooltip = () => {
    const [copiedField, setCopiedField] = useState(null);

    if (!showTooltip || !tooltipData) return null;

    const handleCopy = async (text, field) => {
      if (!text || text === 'N/A') return;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          const textArea = document.createElement("textarea");
          textArea.value = text;
          textArea.style.position = "fixed";
          textArea.style.left = "-99999px";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
        }

        setCopiedField(field);

        setTimeout(() => {
          setCopiedField(null);
        }, 1500);

      } catch (err) {
        console.error("Copy failed", err);
      }
    };

    const style = {
      position: 'fixed',
      marginLeft: '25px',
      marginTop: '20px',
      zIndex: 9999,
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
      border: '1px solid #e2e8f0',
      width: '280px',
      padding: '16px',
      animation: 'fadeIn 0.2s ease-out',
    };

    if (tooltipPosition.x + 280 > window.innerWidth) {
      style.left = `${window.innerWidth - 300}px`;
    }

    if (tooltipPosition.y - 200 < 0) {
      style.top = `${tooltipPosition.y + 40}px`;
    }

    return (
      <div ref={tooltipRef} style={style}>
        <button
          onClick={closeTooltip}
          style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            background: 'none',
            border: 'none',
            fontSize: '18px',
            cursor: 'pointer',
            color: '#666',
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f1f5f9'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
        >
          &times;
        </button>

        <div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
            <div
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: '#2E6DA4',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                fontWeight: '600',
                marginRight: '12px',
              }}
            >
              {tooltipData.name.split(' ').map(n => n[0]).join('').toUpperCase()}
            </div>
            <div>
              <h6 id="tooltip-name" style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#1e293b' }}>
                {tooltipData.name}
              </h6>
              <small id="tooltip-role" style={{ color: '#64748b', fontSize: '11px' }}>
                {tooltipData.role}
              </small>
            </div>
          </div>

          <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '12px' }}>
            <div style={{ marginBottom: '8px' }}>
              <div style={{ fontSize: '9.5px', color: '#98A2B3', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', marginBottom: '4px' }}>
                Phone Number
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13px', color: '#1e293b' }}>
                <span style={{ flex: 1 }} id="tooltip-phone">{tooltipData.phone}</span>
                {tooltipData.phone !== 'N/A' && (
                  <button
                    onClick={() => handleCopy(tooltipData.phone, 'phone')}
                    style={{
                      background: copiedField === 'phone' ? '#22c55e' : 'none',
                      border: 'none',
                      color: copiedField === 'phone' ? 'white' : '#2E6DA4',
                      cursor: 'pointer',
                      fontSize: copiedField === 'phone' ? '14px' : '16px',
                      padding: 0,
                      borderRadius: '50%',
                      transition: 'all 0.2s ease',
                      width: '28px',
                      height: '28px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: copiedField === 'phone' ? '0 2px 5px rgba(34, 197, 94, 0.3)' : 'none',
                      marginLeft: '8px',
                    }}
                    title={copiedField === 'phone' ? "Copied!" : "Copy Phone Number"}
                  >
                    {copiedField === 'phone' ? (
                      <i className="bi bi-check" style={{ fontSize: '16px', lineHeight: '1', margin: 0, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}></i>
                    ) : (
                      <i className="fa-regular fa-copy" style={{ fontSize: '16px', lineHeight: '1', margin: 0, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}></i>
                    )}
                  </button>
                )}
              </div>
            </div>

            <div style={{ marginBottom: '8px' }}>
              <div style={{ fontSize: '9.5px', color: '#98A2B3', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', marginBottom: '4px' }}>
                {tooltipData.is_helpdesk === true ? 'Support Team' : 'Department'}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13px', color: '#1e293b' }}>
                <span style={{ flex: 1 }} id="tooltip-department">{tooltipData.department}</span>
                {tooltipData.department !== 'N/A' && (
                  <button
                    onClick={() => handleCopy(tooltipData.department, 'department')}
                    style={{
                      background: copiedField === 'department' ? '#22c55e' : 'none',
                      border: 'none',
                      color: copiedField === 'department' ? 'white' : '#2E6DA4',
                      cursor: 'pointer',
                      fontSize: copiedField === 'department' ? '14px' : '16px',
                      padding: 0,
                      borderRadius: '50%',
                      transition: 'all 0.2s ease',
                      width: '28px',
                      height: '28px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: copiedField === 'department' ? '0 2px 5px rgba(34, 197, 94, 0.3)' : 'none',
                      marginLeft: '8px',
                    }}
                    title={copiedField === 'department' ? "Copied!" : tooltipData.is_helpdesk === true ? "Copy Support Team" : "Copy Department"}
                  >
                    {copiedField === 'department' ? (
                      <i className="bi bi-check" style={{ fontSize: '16px', lineHeight: '1', margin: 0, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}></i>
                    ) : (
                      <i className="fa-regular fa-copy" style={{ fontSize: '16px', lineHeight: '1', margin: 0, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}></i>
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const fetchHolidays = async (bankCode) => {
    if (!bankCode) {
      setHolidays([]);
      return;
    }

    setIsLoadingHolidays(true);
    try {
      let admin_role = "U";

      if (userProfile) {
        if (userProfile.is_admin === true) {
          admin_role = "HO";
        } else if (userProfile.role_name === "SUPER ADMIN") {
          admin_role = "SA";
        }
      }

      const payload = {
        admin_role: admin_role,
        bank_code: bankCode || null,
      };

      console.log("Holidays API Payload:", payload);

      const response = await postDataWithBody(getHolidayList, payload, {});

      if (response && Array.isArray(response)) {
        const bankHolidays = response.filter(holiday => {
          const isActive = holiday.status === 1 || holiday.status === "1" || holiday.activeStatus === true;
          const isForSelectedBank = holiday.bankCode === bankCode ||
                                   holiday.bankCode?.toString() === bankCode.toString();

          return isActive && isForSelectedBank;
        });
        setHolidays(bankHolidays);
      }
    } catch (error) {
      console.error("Error fetching holidays:", error);
      setHolidays([]);
    } finally {
      setIsLoadingHolidays(false);
    }
  };

  const isHoliday = (date) => {
    if (!holidays.length || !ticketData?.originalData?.bankCode) return false;

    const checkDate = new Date(date);

    return holidays.some(holiday => {
      try {
        const holidayFrom = new Date(holiday.fromDate);
        const holidayTo = new Date(holiday.toDate);

        holidayFrom.setHours(0, 0, 0, 0);
        holidayTo.setHours(23, 59, 59, 999);

        const comparisonDate = new Date(checkDate);
        comparisonDate.setHours(12, 0, 0, 0);

        return comparisonDate >= holidayFrom && comparisonDate <= holidayTo;
      } catch (error) {
        console.error("Error checking holiday date:", error);
        return false;
      }
    });
  };

  const isSunday = (date) => {
    return date.getDay() === 0;
  };

  const addDaysExcludingSundaysAndHolidays = (startDate, daysToAdd) => {
    let resultDate = new Date(startDate);
    let addedDays = 0;

    while (addedDays < daysToAdd) {
      resultDate.setDate(resultDate.getDate() + 1);
      if (!isSunday(resultDate) && !isHoliday(resultDate)) {
        addedDays++;
      }
    }

    return resultDate;
  };

  const addHoursExcludingSundaysAndHolidays = (startDate, hoursToAdd) => {
    let resultDate = new Date(startDate);
    let addedHours = 0;

    while (addedHours < hoursToAdd) {
      resultDate.setHours(resultDate.getHours() + 1);
      addedHours++;

      if (isSunday(resultDate) || isHoliday(resultDate)) {
        resultDate.setDate(resultDate.getDate() + 1);
        resultDate.setHours(9, 0, 0, 0);

        while (isSunday(resultDate) || isHoliday(resultDate)) {
          resultDate.setDate(resultDate.getDate() + 1);
        }
      }
    }

    return resultDate;
  };

  const addMinutesExcludingSundaysAndHolidays = (startDate, minutesToAdd) => {
    let resultDate = new Date(startDate);
    let addedMinutes = 0;

    while (addedMinutes < minutesToAdd) {
      resultDate.setMinutes(resultDate.getMinutes() + 1);
      addedMinutes++;

      if (isSunday(resultDate) || isHoliday(resultDate)) {
        resultDate.setDate(resultDate.getDate() + 1);
        resultDate.setHours(9, 0, 0, 0);

        while (isSunday(resultDate) || isHoliday(resultDate)) {
          resultDate.setDate(resultDate.getDate() + 1);
        }
      }
    }

    return resultDate;
  };

  const addDaysExcludingSundays = (startDate, daysToAdd) => {
    let resultDate = new Date(startDate);
    let addedDays = 0;

    while (addedDays < daysToAdd) {
      resultDate.setDate(resultDate.getDate() + 1);
      if (resultDate.getDay() !== 0) {
        addedDays++;
      }
    }

    return resultDate;
  };

  useEffect(() => {
    if (ticketData?.originalData?.bankCode) {
      fetchHolidays(ticketData.originalData.bankCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketData?.originalData?.bankCode, userProfile]);

  const fetchTicketBySeqId = async (grievanceSeqId) => {
    try {
      const profile = await getData(getThemeURL);
      if (!profile || !profile.length) return;
      const user = profile[0];
      let admin_role = "USER";
      if (user.is_admin === true) admin_role = "HO";
      else if (user.role_name === "SUPER ADMIN") admin_role = "SA";
      const payload = {
        admin_role,
        region_id: user.region_id || null,
        userId: user.id || null,
        userLevel: user.userLevel || user.user_level || null,
      };
      const response = await postDataWithBody(fetchGrievanceData, payload, {});
      if (!Array.isArray(response)) return;
      const item = response.find((r) => r.grievanceSeqId === grievanceSeqId);
      if (!item) return;
      const statusMap = {
        837: "Open", 838: "In Progress", 839: "Hold",
        840: "Resolved", 841: "Closed", 842: "Rejected",
        850: "Issue Pending at User Level", 851: "Issue Pending at External Vendor",
      };
      const formatDT = (val) => {
        if (!val) return "N/A";
        const d = new Date(val);
        if (isNaN(d)) return "N/A";
        const dd = String(d.getDate()).padStart(2, "0");
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const yyyy = d.getFullYear();
        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = String(hours % 12 || 12).padStart(2, "0");
        return `${dd}-${mm}-${yyyy} ${hours}:${minutes} ${ampm}`;
      };
      setTicketData({
        id: item.grievanceSeqId,
        bank: item.bankNameShort,
        branch: item.branchNameShort,
        regionName: item.regionName || item.bankNameShort || "N/A",
        subject: item.subject,
        date: formatDT(item.ticketDateAndTime || item.created_on),
        criticality: item.priority,
        status: statusMap[item.status] || "Open",
        handler: item.assignedTeamName,
        type: item.issueTypeName,
        issueTypeName: item.issueTypeName,
        issueTypeSubCatName: item.issueTypeSubCatName,
        userLevels: item.userLevel,
        customerName: item.customerName,
        email: item.email,
        phoneNumber: item.phoneNumber,
        requesterBy: item.requesterBy,
        resolutionMethod: item.resoultionName,
        mediaList: item.mediaList || [],
        originalData: item,
        assignToUserName: item.assignToUserName || "Unassigned",
        slaPaused: item.slaPaused,
        slaPausedAt: item.slaPausedAt || "N/A",
        slaRemainingMinutes: item.slaRemainingMinutes || "N/A",
        resolvedBy: item.resolvedBy || "Not Yet Resolved",
      });
    } catch (err) {
      console.error("Error fetching ticket by seqId:", err);
    }
  };

  useEffect(() => {
    fetchUserProfile();
    getUserProfile();
    const grievanceSeqId = location.state?.grievanceSeqId;
    if (grievanceSeqId && !location.state?.data && !location.state?.eventData) {
      fetchTicketBySeqId(grievanceSeqId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (ticketData?.originalData?.grievanceTicketMapEntity) {
      const hasUserLevel =
        "userLevel" in ticketData.originalData.grievanceTicketMapEntity;

      if (!hasUserLevel) {
        setIsAdminCommenting(true);
      }
    }
  }, [ticketData]);

  // ─── CHANGE 3: Simplified initialStatusOptions to only Open, In Progress, Resolved ───
  useEffect(() => {
    if (ticketData?.status) {
      const allPossibleStatuses = ["Open", "In Progress", "Resolved"];

      const transitions = getStatusTransitions(ticketData.status);

      const combinedOptions = [ticketData.status, ...transitions];
      const uniqueOptions = [...new Set(combinedOptions)];

      const orderedOptions = allPossibleStatuses.filter((status) =>
        uniqueOptions.includes(status)
      );

      setInitialStatusOptions(orderedOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketData?.status]);

  useEffect(() => {
    const checkAndMarkNotificationAsRead = async () => {
      if (ticketData?.originalData?.id) {
        try {
          const notificationsResponse = await getData(getNotificationsList);

          if (notificationsResponse?.data?.length > 0) {
            const matchingNotification = notificationsResponse.data.find(
              (notification) =>
                notification.reportId === ticketData.originalData.id &&
                !notification.isRead
            );

            if (matchingNotification) {
              const readResponse = await getData(
                notificationRead.replace("ID", matchingNotification.id)
              );

              console.log("Notification marked as read:", readResponse);

              window.dispatchEvent(new CustomEvent("refreshNotificationCount"));
            }
          }
        } catch (error) {
          console.error("Error checking/marking notification as read:", error);
        }
      }
    };

    if (ticketData?.originalData?.id) {
      checkAndMarkNotificationAsRead();
    }
  }, [ticketData?.originalData?.id]);

  useEffect(() => {
    if (location.state?.data || location.state?.eventData) {
      sessionStorage.setItem(
        "ticketData",
        JSON.stringify(location.state?.data || location.state?.eventData)
      );
    }
  }, [location.state]);

  useEffect(() => {
    if (
      ticketData?.originalData?.commentsMap &&
      Array.isArray(ticketData.originalData.commentsMap)
    ) {
      const dynamicComments = ticketData.originalData.commentsMap.map(
        (commentData, index) => {
          const formatDate = (dateString) => {
            try {
              const date = new Date(dateString);
              const dd = String(date.getDate()).padStart(2, "0");
              const mm = String(date.getMonth() + 1).padStart(2, "0");
              const yyyy = String(date.getFullYear());

              let hours = date.getHours();
              const minutes = String(date.getMinutes()).padStart(2, "0");
              const ampm = hours >= 12 ? "PM" : "AM";
              hours = hours % 12 || 12;
              const formattedHours = String(hours).padStart(2, "0");

              return `${dd}-${mm}-${yyyy} ${formattedHours}:${minutes} ${ampm}`;
            } catch (error) {
              return dateString;
            }
          };

          const generateAvatar = (userName) => {
            if (!userName) return "US";

            const nameString = userName.label || userName;

            if (nameString) {
              const nameParts = nameString.split(" ");
              const firstName = nameParts[0] || "";
              const lastName = nameParts[1] || "";

              const firstChar = firstName.charAt(0).toUpperCase() || "";
              const secondChar = lastName.charAt(0).toUpperCase() || "";

              return `${firstChar}${secondChar}` || "US";
            }
            return "US";
          };

          const letterCount = commentData.comments
            ? `${commentData.comments.replace(/[^a-zA-Z]/g, "").length}/1000`
            : "0/1000";

          return {
            id: commentData.id || index + 1,
            user: commentData?.userName || commentData?.userName,
            userId: commentData?.createdBy || commentData?.commentsUpdatedBy,
            avatar: generateAvatar(
              commentData?.userName || commentData?.userName
            ),
            date: formatDate(
              commentData.commentsDateAndTime || commentData.createdOn
            ),
            text: commentData.comments || "",
            letterCount: letterCount,
          };
        }
      );

      setComments(dynamicComments);
    } else {
      setComments([]);
    }
  }, [ticketData?.originalData?.commentsMap, UserList]);

  useEffect(() => {
    if (
      ticketData?.originalData?.actionList &&
      ticketData.originalData.actionList.length > 0
    ) {
      const latestAction = ticketData.originalData.actionList[0];
      setActionTaken(latestAction.actionTaken || "");
      setRootCause(latestAction.rootCause || "");
      setResolutionSteps(latestAction.resolutionSteps || "");
    }
  }, [ticketData]);

  useEffect(() => {
    if (currentStatus === "Open" || currentStatus === "Rejected") {
      setIsRootCauseDisabled(true);
      setIsActionTakenDisabled(true);
      setIsResolutionStepsDisabled(true);
    } else if (currentStatus === "In Progress") {
      setIsRootCauseDisabled(false);
      setIsActionTakenDisabled(false);
      setIsResolutionStepsDisabled(false);
    } else if (currentStatus === "Resolved") {
      setIsRootCauseDisabled(false);
      setIsActionTakenDisabled(false);
      setIsResolutionStepsDisabled(false);
    } else if (currentStatus === "Closed") {
      setIsRootCauseDisabled(true);
      setIsActionTakenDisabled(true);
      setIsResolutionStepsDisabled(true);
    }

    if (ticketData?.status === "Resolved") {
      setIsRootCauseDisabled(true);
      setIsActionTakenDisabled(true);
      setIsResolutionStepsDisabled(true);
    }
  }, [currentStatus, ticketData?.status]);


  const fetchUserProfile = async () => {
    try {
      const response = await getData(getThemeURL);
      if (response && Array.isArray(response) && response.length > 0) {
        setUser(response[0].id);
        setUserId(response[0].first_name + (response[0].last_name ? " " + response[0].last_name : ""));
        setUserRole(response[0].role_name);
        setisAdmin(response[0].is_admin);
        setUserLevel(response[0].user_level || response[0].userLevel);
        setEscalationUserId(response[0].id);
        setUserProfile(response[0]);
        setSupportAdmin(response[0].is_dep_admin);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const openTransferReasonModal = (reason) => {
    setSelectedTransferReason(reason);
    setShowTransferReasonModal(true);
  };

  const closeTransferReasonModal = () => {
    setShowTransferReasonModal(false);
    setSelectedTransferReason("");
  };

  const onEscalationLevelChange = (e) => {
    const level = e.target.value;
    setEscalationLevel(level);
    if (level) {
      setEscalationComment('');
      setShowEscalationModal(true);
    }
  };

  const handleEscalationModalClose = () => {
    setShowEscalationModal(false);
    if (escalationType === 'manual') {
      setEscalationLevel('');
    }
    setEscalationComment('');
  };

  const submitEscalation = async () => {
    if (escalationComment.trim() === '') {
      toast.error('Comment is required');
      return;
    }
    setIsSubmittingEscalation(true);
    try {
      const formDataToSend = new FormData();

      let remarkField;
      if (escalationLevel === 'L1') {
        remarkField = 'escalateRemarks1';
      } else if (escalationLevel === 'L2') {
        remarkField = 'escalateRemarks2';
      } else if (escalationLevel === 'L3') {
        remarkField = 'escalateRemarks3';
      }

      const payload = {
        id: ticketData?.originalData?.id,
        updatedby: escalationUserId,
        [remarkField]: escalationComment,
      };

      formDataToSend.append('grievance', JSON.stringify(payload));
      const emptyBlob = new Blob([], { type: "application/octet-stream" });
      formDataToSend.append("files", emptyBlob, "empty.bin");

      let response;
      if (escalationLevel === 'L1') {
        response = await postDataWithBody(manualEscalateL1, formDataToSend, {});
      } else if (escalationLevel === 'L2') {
        response = await postDataWithBody(manualEscalateL2, formDataToSend, {});
      } else if (escalationLevel === 'L3') {
        response = await postDataWithBody(manualEscalateL3, formDataToSend, {});
      }

      if (response && response.status === "success") {
        toast.success(response.msg || `Ticket escalated to ${escalationLevel} successfully!`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });

        const updatedTicketData = {
          ...ticketData,
          originalData: {
            ...ticketData.originalData,
            userLevel: escalationLevel
          }
        };

        sessionStorage.setItem("ticketData", JSON.stringify(updatedTicketData));

        navigate("../grievance");
      } else {
        throw new Error(response?.msg || "Failed to escalate ticket");
      }
    } catch (error) {
      console.error("Escalation error:", error);
      toast.error(error.message || "Failed to escalate ticket", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      setEscalationLevel('');
    } finally {
      setShowEscalationModal(false);
      setEscalationComment('');
      setIsSubmittingEscalation(false);
    }
  };

  const formatDateTimeForAPI = (dateTimeString) => {
    if (!dateTimeString) return '';

    const date = new Date(dateTimeString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, '0');

    return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
  };
  // eslint-disable-next-line no-unused-vars
  const handleCrossDepartmentTransfer = async () => {
    if (!transferData.targetDepartment || !transferData.transferReason) {
      toast.error('Please fill all required fields');
      return;
    }

    if (customPriority) {
      const selectedDateTime = new Date(customPriority);
      const currentDateTime = new Date();

      selectedDateTime.setSeconds(0, 0);
      currentDateTime.setSeconds(0, 0);

      if (selectedDateTime < currentDateTime) {
        setSlaDeadlineError("SLA deadline cannot be in the past. Please choose a valid future date and time.");
        return;
      }

      if (isSunday(selectedDateTime) || isHoliday(selectedDateTime)) {
        setSlaDeadlineError("SLA deadline cannot fall on a Sunday or holiday. Please choose a working day.");
        return;
      }
    }

    setIsSubmittingCrossDepartment(true);
    try {
      const formDataToSend = new FormData();

      const priorityDateTime = customPriority || calculatePriorityDateTime();

      const payload = {
        grievanceSeqIdString: ticketData?.id,
        targetDepartmentId: parseInt(transferData.targetDepartment),
        transferReason: transferData.transferReason,
        transferType: transferData.transferType,
        initiatedBy: parseInt(ticketData?.originalData?.createdBy),
        createdBy: crossDepartmentUserId ? parseInt(crossDepartmentUserId) : parseInt(ticketData?.originalData?.createdBy),
        userLevel: ticketData?.userLevels,
        currentStatus: parseInt(ticketData?.originalData?.status),
        resSLADateAndTimeString: priorityDateTime ? formatDateTimeForAPI(priorityDateTime) : "",
        is_deleted: false,
      };

      formDataToSend.append('transfer', JSON.stringify(payload));

      if (selectedImages && selectedImages.length > 0) {
        selectedImages.forEach((imgObj) => {
          if (imgObj.file instanceof File) {
            formDataToSend.append("files", imgObj.file);
          }
        });
      } else {
        const emptyBlob = new Blob([], { type: "application/octet-stream" });
        formDataToSend.append("files", emptyBlob, "empty.bin");
      }

      const response = await postDataWithFiles(createCrossDepartment, formDataToSend);

      if (response && response.status === "success") {
        toast.success(response.msg || "Ticket transferred to cross support team successfully!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });

        setTransferData({
          targetDepartment: '',
          transferReason: '',
          transferType: '',
          supportingRemarks: ''
        });
        setSelectedImages([]);
        setCrossDepartmentUserId(null);
        setCustomPriority('');
        setSlaDeadlineError('');
        setShowCrossDepartmentModal(false);

        navigate("../grievance");
      } else {
        throw new Error(response?.msg || "Failed to transfer ticket to cross support team");
      }
    } catch (error) {
      console.error("Cross department transfer error:", error);
      toast.error(error.message || "Failed to transfer ticket to cross support team", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsSubmittingCrossDepartment(false);
    }
  };

  const handleReassignModalClose = () => {
    setShowReassignModal(false);
    setTempReassignDescription("");
  };

  const getDepartments = async (assignedTeamId) => {
    try {
      const response = await getData(getDepartmentsCurrent.replace("DEPTID", assignedTeamId));
      if (Array.isArray(response)) {
        setDepartments(response);
      } else {
        setDepartments([]);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      setDepartments([]);
      toast.error("Failed to load support team", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  useEffect(() => {
    if (ticketData?.originalData?.assignedTeam) {
      getDepartments(ticketData.originalData.assignedTeam);
    }
  }, [ticketData?.originalData?.assignedTeam]);

  console.log("Fetching cross department LO users for userId:", userId);

  useEffect(() => {
    if (ticketData?.originalData?.grievanceReassignmentLevelEntities &&
        ticketData.originalData.grievanceReassignmentLevelEntities.length > 0 &&
        user) {

      const latestReassignment = ticketData.originalData.grievanceReassignmentLevelEntities[0];

      if (latestReassignment.reassignmentUser === user) {
        setReassignmentDescription(latestReassignment.reassignmentDescription || '');
      } else {
        setReassignmentDescription('');
      }
    } else {
      setReassignmentDescription('');
    }
  }, [ticketData?.originalData?.grievanceReassignmentLevelEntities, user]);

  const getCrossDepartmentLOUsers = async (userId, userLevelFromTheme) => {
    console.log("Fetching cross department LO users for userId:", userId);
    console.log("L2 userLevelFromTheme", userLevelFromTheme);
    try {
      let response;
      const bankCode = ticketData.bankCode;
      const branchCode = ticketData.branchCode;

      if (userLevelFromTheme === "L1") {
        console.log("L1 login LO Users userId inside 1:", userId);
        const url = getUsersByUserLevelExceptCurrent
          .replace("USERLEVEL", "L1")
          .replace("USERID", userId)
          .replace("BankCode", bankCode)
          .replace("BranchCode", branchCode);
        response = await getData(url);
      } else if (userLevelFromTheme === "L2" || userLevelFromTheme === "L3") {
        console.log("L1 login LO Users userId inside 2:", userId);
        const url = getBranchUserList
          .replace("USERLEVEL", "L1")
          .replace("BankCode", bankCode)
          .replace("BranchCode", branchCode);
        response = await getData(url);
        console.log("L2 login LO Users response:", response);
      }
      console.log("Cross Department LO Users response:", response);
      if (Array.isArray(response)) {
        setCrossDepartmentLOUsers(response);
      } else {
        setCrossDepartmentLOUsers([]);
      }
    } catch (error) {
      console.error("Error fetching cross department users:", error);
      setCrossDepartmentLOUsers([]);
      // toast.error("Failed to load users", {
      //   position: toast.POSITION.TOP_CENTER,
      //   autoClose: 2000,
      // });
    }
  };

  useEffect(() => {
    if (user && userLevel) {
      getCrossDepartmentLOUsers(user, userLevel);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, userLevel]);

  const fetchPriorityData = async (selectedPriority) => {
    try {
      const response = await getData(getAllPriority.replace("PRIORITY", selectedPriority));
      console.log("Priority response:", response);
      setPriorityTime(response);
    } catch (error) {
      console.error("Error fetching priority data", error);
    }
  };

  useEffect(() => {
    if (showCrossDepartmentModal && ticketData?.criticality) {
      fetchPriorityData(ticketData.criticality);
    }
  }, [showCrossDepartmentModal, ticketData?.criticality]);

  useEffect(() => {
    if (showCrossDepartmentModal && priorityTime) {
      const recalculatedDateTime = calculatePriorityDateTime();
      if (recalculatedDateTime && !customPriority) {
        setCustomPriority(recalculatedDateTime);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [holidays, showCrossDepartmentModal, priorityTime, customPriority]);

  const calculatePriorityDateTime = () => {
    if (!priorityTime) return '';

    const currentDate = new Date();
    let targetDate = new Date(currentDate);

    const { maxResTimeValue, maxResTimeType } = priorityTime;

    if (ticketData?.originalData?.bankCode && holidays.length > 0) {
      switch (maxResTimeType.toLowerCase()) {
        case "minutes":
          targetDate = addMinutesExcludingSundaysAndHolidays(currentDate, maxResTimeValue);
          break;
        case "hours":
          targetDate = addHoursExcludingSundaysAndHolidays(currentDate, maxResTimeValue);
          break;
        case "days":
          targetDate = addDaysExcludingSundaysAndHolidays(currentDate, maxResTimeValue);
          break;
        default:
          break;
      }
    } else {
      switch (maxResTimeType.toLowerCase()) {
        case "minutes":
          targetDate.setMinutes(targetDate.getMinutes() + maxResTimeValue);
          break;
        case "hours":
          targetDate.setHours(targetDate.getHours() + maxResTimeValue);
          if (targetDate.getDay() === 0) {
            targetDate.setDate(targetDate.getDate() + 1);
          }
          break;
        case "days":
          targetDate = addDaysExcludingSundays(currentDate, maxResTimeValue);
          break;
        default:
          break;
      }
    }

    const year = targetDate.getFullYear();
    const month = String(targetDate.getMonth() + 1).padStart(2, '0');
    const day = String(targetDate.getDate()).padStart(2, '0');
    const hours = String(targetDate.getHours()).padStart(2, '0');
    const minutes = String(targetDate.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      if (userProfile && userProfile.length > 0) {
        getUserList(userProfile[0]);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const createPayload = (profile) => {
    let admin_role = "U";

    if (profile.is_admin === true) {
      admin_role = "HO";
    } else if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    }

    return {
      admin_role: admin_role,
      bank_code: profile.bank_code || null,
      branch_code: profile.branch_code || null,
    };
  };

  const getUserList = async (profile) => {
    try {
      const payload = createPayload(profile);
      const fetchedUsers = await postDataWithBody(
        getUsersFromAppByRole,
        payload,
        {}
      );
      const sortedUsers = fetchedUsers.sort((a, b) =>
        a.first_name > b.first_name ? 1 : -1
      );
      const userList = sortedUsers.map((user) => ({
        label: `${user.first_name} ${user.last_name}`,
        value: user.id,
        created_by: user.created_by,
      }));
      setUserList(userList);
    } catch (error) {
      console.error("Error fetching user list:", error);
      toast.error("Failed to load user list");
    }
  };



  useEffect(() => {
    if (ticketData?.mediaList && ticketData.mediaList.length > 0) {
      setMediaList(ticketData.mediaList);
    }
  }, [ticketData]);

  const displayData = (data) => data || "N/A";

  const formatReopenedDateTime = (dateString) => {
    if (!dateString) return "N/A";

    try {
      const date = new Date(dateString);

      if (isNaN(date.getTime())) {
        return dateString;
      }

      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = String(date.getFullYear());

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;
      const formattedHours = String(hours).padStart(2, "0");

      return `${dd}-${mm}-${yyyy} ${formattedHours}:${minutes} ${ampm}`;
    } catch (error) {
      console.error("Error formatting reopened date:", error);
      return dateString || "N/A";
    }
  };

  const getStatusStyling = (status) => {
    if (!status)
      return { dotColor: "#808080", textColor: "#6b7280" };

    let dotColor, textColor;
    switch (status) {
      case "Open":
        dotColor = "rgba(233, 80, 96, 0.5)";
        textColor = "#E95060";
        break;
      case "Closed":
        dotColor = "#22c55e";
        textColor = "#166534";
        break;
      case "In Progress":
        dotColor = "#f59e0b";
        textColor = "#92400e";
        break;
      case "Issue Pending at User Level":
        dotColor = "#8b5cf6";
        textColor = "#7c3aed";
        break;
      case "Issue Pending at External Vendor":
        dotColor = "#ec4899";
        textColor = "#db2777";
        break;
      case "Rejected":
        dotColor = "#dc3545";
        textColor = "#dc3545";
        break;
      default:
        dotColor = "#6b7280";
        textColor = "#6b7280";
    }
    return { dotColor, textColor };
  };

  const getPriorityStyling = (priority) => {
    if (!priority)
      return { dotColor: "#808080", textColor: "#6b7280" };

    let dotColor, textColor;
    switch (priority.toUpperCase()) {
      case "CRITICAL":
      case "HIGH":
        dotColor = "#ef4444";
        textColor = "#db0404";
        break;
      case "MEDIUM":
        dotColor = "#f59e0b";
        textColor = "#FFA100";
        break;
      case "LOW":
        dotColor = "#3b82f6";
        textColor = "#40BAC2";
        break;
      default:
        dotColor = "#6b7280";
        textColor = "#808080";
    }
    return { dotColor, textColor };
  };

  // eslint-disable-next-line no-unused-vars
  const statusStyling = getStatusStyling(ticketData?.status);
  // eslint-disable-next-line no-unused-vars
  const priorityStyling = getPriorityStyling(ticketData?.criticality);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { isTextFieldDisable } = location.state || {};
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const extractFilenameFromUrl = (url) => {
    if (!url) return '';
    try {
      const urlWithoutParams = url.split('?')[0];
      const parts = urlWithoutParams.split('/');
      const filename = parts[parts.length - 1];
      return decodeURIComponent(filename);
    } catch (error) {
      console.error('Error extracting filename:', error);
      return url;
    }
  };

  const getFileExtension = (urlOrFilename) => {
    if (!urlOrFilename) return '';
    const filename = extractFilenameFromUrl(urlOrFilename);
    const lastDot = filename.lastIndexOf('.');
    if (lastDot === -1) return '';
    return filename.substring(lastDot + 1).toLowerCase();
  };

  const getFileNameWithoutExtension = (fileName) => {
    if (!fileName) return "Untitled";
    const extractedName = extractFilenameFromUrl(fileName);
    const lastDot = extractedName.lastIndexOf('.');
    if (lastDot === -1) return extractedName;
    return extractedName.substring(0, lastDot);
  };

  const isPdfFile = (filePath) => {
    if (!filePath) return false;
    const extension = getFileExtension(filePath);
    return extension === 'pdf';
  };

  const isImageFile = (filePath) => {
    if (!filePath) return false;
    const extension = getFileExtension(filePath);
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    return imageExtensions.includes(extension);
  };

  const isVideoFile = (filePath) => {
    if (!filePath) return false;
    const extension = getFileExtension(filePath);
    const videoExtensions = ['mp4', 'mov', 'avi', 'webm', 'mkv', 'flv'];
    return videoExtensions.includes(extension);
  };

  // ─── CHANGE 2: getDynamicSteps simplified to Open → In Progress → Resolved ───
  const getDynamicSteps = (currentStatus, ticketData) => {
    console.log(currentStatus, "Current Status");
    const allSteps = ["Open", "In Progress", "Resolved"];
    const rejectedSteps = ["Open", "Rejected"];

    if (currentStatus === "Rejected") {
      return rejectedSteps;
    }

    const statusHistory = ticketData?.originalData?.grievanceStatusMapEntities || [];

    const statusMap = {
      837: "Open",
      838: "In Progress",
      840: "Resolved",
      841: "Closed",
      842: "Rejected",
      850: "Issue Pending at User Level",
      851: "Issue Pending at External Vendor"
    };

    const timeline = ["Open"];

    if (statusHistory.length > 0) {
      const sortedHistory = [...statusHistory].sort((a, b) =>
        new Date(a.createdOn) - new Date(b.createdOn)
      );

      console.log("Sorted History:", sortedHistory);

      sortedHistory.forEach((item, index) => {
        const statusText = statusMap[item.status] || item.statusText || "Unknown";
        // Only include statuses in our simplified flow
        if (allSteps.includes(statusText) || statusText === "Rejected") {
          if (!(statusText === "Open" && index === 0)) {
            timeline.push(statusText);
          }
        }
      });

      console.log("Timeline from history:", timeline);
    }

    if (currentStatus && timeline[timeline.length - 1] !== currentStatus) {
      if (allSteps.includes(currentStatus) || currentStatus === "Rejected") {
        timeline.push(currentStatus);
      }
    }

    const lastStatus = timeline[timeline.length - 1];
    const lastIndex = allSteps.indexOf(lastStatus);

    if (lastStatus !== "Resolved" && lastStatus !== "Rejected") {
      if (lastIndex !== -1) {
        for (let i = lastIndex + 1; i < allSteps.length; i++) {
          timeline.push(allSteps[i]);
        }
      } else {
        timeline.push("In Progress", "Resolved");
      }
    }

    console.log("Final Timeline:", timeline);
    return timeline;
  };

  const getCurrentStepIndex = () => {
    const steps = getDynamicSteps(currentStatus, ticketData);

    let stepIndex = -1;
    for (let i = steps.length - 1; i >= 0; i--) {
      if (steps[i].toLowerCase() === (currentStatus || "").toLowerCase()) {
        stepIndex = i;
        break;
      }
    }

    return stepIndex === -1 ? 0 : stepIndex;
  };

  const handleCommentChange = (e) => {
    const inputText = e.target.value;
    if (inputText.replace(/[^a-zA-Z]/g, "").length <= 1000) {
      setComment(inputText);
    }
  };
  console.log(handleCommentChange);

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;

    if (newStatus === "Reopen") {
      console.log("Opening reopen modal");
      setShowReopenModal(true);
      console.log("showReopenModal state:", showReopenModal);
      return;
    }

    // Save current field values for the status we're leaving
    statusFieldSnapshot.current[currentStatus] = {
      actionTaken,
      rootCause,
      resolutionSteps,
    };

    setCurrentStatus(newStatus);
    setStatusError("");

    if (newStatus === "Open") {
      // Open: always clear
      setActionTaken("");
      setRootCause("");
      setResolutionSteps("");
      setRootCauseError("");
    } else {
      // Restore saved values for the status we're switching to, or empty if none.
      // Root Cause is an exception: if this status has never been visited
      // before, carry forward whatever Root Cause was just entered rather
      // than resetting it to blank (e.g. In Progress -> Resolved).
      const saved = statusFieldSnapshot.current[newStatus] || {};
      setActionTaken(saved.actionTaken || "");
      setRootCause(saved.rootCause || rootCause);
      setResolutionSteps(saved.resolutionSteps || "");
      setRootCauseError("");
    }

    const shouldShowReassignment = (() => {
      if (!ticketData?.originalData?.grievanceTicketMapEntity?.disable === false) {
        return false;
      }

      if ((userLevel === "L2" || userLevel === "L3") &&
          (newStatus === "Resolved" || newStatus === "Issue Pending at User Level")) {
        return true;
      }

      if (userLevel === "L1" && newStatus === "In Progress") {
        return true;
      }

      return false;
    })();

    if (shouldShowReassignment) {
      setReassignmentRequired(true);
      setTempReassignDescription(reassignDescription);
      setShowReassignModal(true);
    } else {
      setReassignmentRequired(false);
      setReassignmentError("");
      setReassignmentPrefix("");
      setReassignDescription("");
      setTempReassignDescription("");
      if (reassignmentPrefix) {
        setComment("");
      }
    }
  };

  const buildCommentObject = (text, existingComments) => {
    let avatar = "";
    const words = userId.split(/\s+/);

    if (words.length >= 2) {
      avatar = (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
    } else if (words.length === 1 && words[0].length >= 2) {
      avatar = words[0].charAt(0).toUpperCase();
    } else if (words.length === 1 && words[0].length === 1) {
      avatar = words[0].toUpperCase();
    } else {
      avatar = "US";
    }

    const date = new Date();
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = String(date.getFullYear()).toString();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, "0");
    const formattedTime = `${formattedHours}:${minutes} ${ampm}`;
    const formattedDateTime = `${dd}-${mm}-${yyyy} ${formattedTime}`;

    return {
      id: existingComments.length + 1,
      user: userId,
      avatar: avatar,
      date: formattedDateTime,
      text,
      letterCount: text.replace(/[^a-zA-Z]/g, "").length,
    };
  };

  const handleCommentSubmit = () => {
    if (comment.trim()) {
      if (comment.replace(/[^a-zA-Z]/g, "").length > 500) {
        setCommentError("Comment exceeds 500 character limit");
        return;
      }

      const newComment = buildCommentObject(comment, comments);

      setComments([...comments, newComment]);
      setComment("");
      setReassignmentPrefix("");
      setStatusError("");
      setCommentError("");
    }
  };

  const handleMediaClick = (media, index) => {
    setCurrentImageIndex(index);
    setModalContent({
      ...media,
      isPdf: isPdfFile(media.mediaPath),
    });
    setShowModal(true);
  };

  const MediaModal = () => {
    const [imageZoom, setImageZoom] = useState(1);
    const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

    if (!showModal || !modalContent) return null;

    const handleZoomIn = () => {
      setImageZoom((prev) => Math.min(prev + 0.25, 3));
    };

    const handleZoomOut = () => {
      setImageZoom((prev) => Math.max(prev - 0.25, 0.25));
    };

    const handleResetZoom = () => {
      setImageZoom(1);
      setImagePosition({ x: 0, y: 0 });
    };

    const handleMouseDown = (e) => {
      if (imageZoom > 1) {
        setIsDragging(true);
        setDragStart({
          x: e.clientX - imagePosition.x,
          y: e.clientY - imagePosition.y,
        });
      }
    };

    const handleMouseMove = (e) => {
      if (isDragging && imageZoom > 1) {
        setImagePosition({
          x: e.clientX - dragStart.x,
          y: e.clientY - dragStart.y,
        });
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    const handleWheel = (e) => {
      e.preventDefault();
      if (e.deltaY < 0) {
        handleZoomIn();
      } else {
        handleZoomOut();
      }
    };

    const isImage = isImageFile(modalContent.mediaPath) || modalContent.type === "image";
    const isPdf = isPdfFile(modalContent.mediaPath) || modalContent.type === "pdf" || modalContent.isPdf;
    const isVideo = isVideoFile(modalContent.mediaPath) || modalContent.type === "video";

    return createPortal(
      <div
        className="fixed inset-0 flex items-center justify-center z-50"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2000,
        }}
        onClick={(e) => {
          if (e.target === e.currentTarget) setShowModal(false);
        }}
      >
        <div
          className="bg-white rounded-lg max-w-4xl max-h-[90vh] overflow-hidden flex flex-col"
          style={{
            backgroundColor: "white",
            borderRadius: "16px",
            width: "90%",
            maxWidth: "900px",
            maxHeight: "90vh",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.15)",
            animation: "fadeIn 0.3s ease-out",
            border: "1px solid #e0e0e0",
            display: "flex",
            marginLeft: "60px",
            flexDirection: "column",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px 20px",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <h2 style={{ fontWeight: "600", fontSize: "18px", color: "#333", marginBottom: "4px" }}>
                  {getFileNameWithoutExtension(modalContent.fileName)}
                </h2>
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {isImage && (
                <>
                  <button onClick={handleZoomOut} style={{ background: "#f5f5f5", border: "1px solid #ddd", borderRadius: "4px", width: "32px", height: "32px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", color: "#666" }} title="Zoom Out">−</button>
                  <span style={{ fontSize: "12px", color: "#666", minWidth: "40px", textAlign: "center" }}>{Math.round(imageZoom * 100)}%</span>
                  <button onClick={handleZoomIn} style={{ background: "#f5f5f5", border: "1px solid #ddd", borderRadius: "4px", width: "32px", height: "32px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", color: "#666" }} title="Zoom In">+</button>
                  <button onClick={handleResetZoom} style={{ background: "#f5f5f5", border: "1px solid #ddd", borderRadius: "4px", padding: "6px 10px", cursor: "pointer", fontSize: "12px", color: "#666" }} title="Reset Zoom">Reset</button>
                </>
              )}
              <button onClick={() => setShowModal(false)} style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer", color: "#888", width: "28px", height: "28px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>&times;</button>
            </div>
          </div>

          <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: "0", minHeight: 0 }}>
            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: isImage ? "center" : "stretch",
                padding: isImage ? "20px" : "0",
                backgroundColor: isImage ? "#f9f9f9" : "#fff",
                overflow: isImage && imageZoom > 1 ? "hidden" : "auto",
                minHeight: 0,
              }}
            >
              {isPdf ? (
                <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
                  <iframe src={modalContent.url || modalContent.mediaPath} style={{ width: "100%", height: "100%", border: "none", borderRadius: "4px", boxShadow: "0 2px 10px rgba(0,0,0,0.1)", minHeight: "500px" }} title={modalContent.name || modalContent.fileName} />
                </div>
              ) : isImage ? (
                <div
                  style={{ width: "100%", height: "100%", flex: 1, minHeight: 0, maxHeight: "70vh", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden", cursor: imageZoom > 1 ? (isDragging ? "grabbing" : "grab") : "default", position: "relative" }}
                  onMouseDown={handleMouseDown}
                  onMouseMove={handleMouseMove}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={handleMouseUp}
                  onWheel={handleWheel}
                >
                  <img
                    src={modalContent.url || modalContent.mediaPath}
                    alt={modalContent.name || modalContent.fileName}
                    style={{ maxWidth: imageZoom === 1 ? "100%" : "none", maxHeight: imageZoom === 1 ? "100%" : "none", transform: `scale(${imageZoom}) translate(${imagePosition.x / imageZoom}px, ${imagePosition.y / imageZoom}px)`, transition: isDragging ? "none" : "transform 0.2s ease", boxShadow: "0 2px 10px rgba(0,0,0,0.1)", objectFit: "contain", userSelect: "none", pointerEvents: "none" }}
                    onError={(e) => { e.target.style.display = "none"; }}
                    draggable={false}
                  />
                </div>
              ) : isVideo ? (
                <div style={{ width: "100%", height: "100%", flex: 1, minHeight: 0, maxHeight: "70vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <video
                    src={modalContent.url || modalContent.mediaPath}
                    controls
                    autoPlay
                    style={{ maxWidth: "100%", maxHeight: "100%", borderRadius: "4px", boxShadow: "0 2px 10px rgba(0,0,0,0.1)", background: "#000" }}
                  />
                </div>
              ) : (
                <div style={{ backgroundColor: "#fff", padding: "30px", borderRadius: "8px", textAlign: "center", boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
                  <div style={{ width: "60px", height: "60px", borderRadius: "50%", backgroundColor: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 15px", fontSize: "24px", color: "#888" }}>📄</div>
                  <h3 style={{ marginBottom: "10px", color: "#333" }}>Preview not available</h3>
                  <p style={{ color: "#666", marginBottom: "20px" }}>Only images and PDF files can be previewed.</p>
                </div>
              )}
            </div>
          </div>

          <div style={{ borderTop: "1px solid #f0f0f0", padding: "16px 20px", backgroundColor: "#FAFAFA" }}></div>
        </div>
      </div>,
      document.body
    );
  };

  const handleSubmit = async () => {
    setRootCauseError("");
    setStatusError("");
    setCommentError("");
    setReassignmentError("");

    if (currentStatus === "Resolved" && !rootCause.trim()) {
      setRootCauseError("Please provide the Root Cause before resolving the ticket");
      return;
    }

    let effectiveComments = comments;
    if (comment.trim()) {
      if (comment.replace(/[^a-zA-Z]/g, "").length > 500) {
        setCommentError("Comment exceeds 500 character limit");
        return;
      }
      const draftComment = buildCommentObject(comment, comments);
      effectiveComments = [...comments, draftComment];
      setComments(effectiveComments);
      setComment("");
      setReassignmentPrefix("");
    }

    const originalCommentsCount = ticketData?.originalData?.commentsMap?.length || 0;
    const newComments = effectiveComments.slice(originalCommentsCount);
    if (newComments.length === 0) {
      setCommentError("Please add a comment before submitting");
      return;
    }

    if (reassignmentRequired && !reassignDescription.trim()) {
      setReassignmentError("Please fill the resolved description in the popup and then submit");
      return;
    }

    setIsSubmitting(true);
    setLoader(true);
    try {
      const formDataToSend = new FormData();

      const newCommentsForSubmission = newComments.map((comment) => ({
        grievanceId: ticketData.originalData.id,
        commentsUpdatedBy: user,
        createdBy: user,
        comments: comment.text,
        commentsDateAndTimeString: comment.date,
      }));

      const grievanceData = {
        id: ticketData.originalData.id,
        updated_by: user,
        currentAction: {
          assignedTo: user,
          actionTaken: actionTaken,
          rootCause: rootCause,
          resolutionSteps: resolutionSteps,
        },
        commentsMap: newCommentsForSubmission,
      };

      if (userLevel === "L1" && currentStatus === "Issue Pending at User Level") {
        grievanceData.reassignment_user = 0;
        grievanceData.reassignment_user_level = "";
        grievanceData.reassignment_description = "";
        grievanceData.updated_by_user_level = "";
      } else if (reassignmentRequired && reassignDescription.trim()) {
        let reassignmentUser;
        let reassignmentUserLevel;

        if (userLevel === "L1") {
          const ticketUserLevel = ticketData?.originalData?.userLevel;
          reassignmentUserLevel = ticketUserLevel;

          if (ticketUserLevel === "L2") {
            reassignmentUser = ticketData?.originalData?.acceptedByL2;
          } else if (ticketUserLevel === "L3") {
            reassignmentUser = ticketData?.originalData?.acceptedByL3;
          }
        } else if (userLevel === "L2" || userLevel === "L3") {
          reassignmentUser = ticketData?.originalData?.createdBy;
          reassignmentUserLevel = "L1";
        }

        grievanceData.reassignment_user = reassignmentUser;
        grievanceData.reassignment_user_level = reassignmentUserLevel;
        grievanceData.reassignment_description = reassignDescription;
        grievanceData.updated_by_user_level = userLevel;
      }

      formDataToSend.append("grievance", JSON.stringify(grievanceData));

      if (selectedImages && selectedImages.length > 0) {
        selectedImages.forEach((imgObj) => {
          if (imgObj.file instanceof File) {
            formDataToSend.append("files", imgObj.file);
          }
        });
      } else {
        const emptyBlob = new Blob([], { type: "application/octet-stream" });
        formDataToSend.append("files", emptyBlob, "empty.bin");
      }

      let response;
      console.log("currentStatus", currentStatus);

      const hasUserLevel = userLevel !== null && userLevel !== undefined;

      const shouldDisableStatusDropdown = hasUserLevel
        ? isStatusClosedOrRejected ||
          hasActionMessage ||
          userRole === "SUPER ADMIN" ||
          isAdmin === true ||
          ticketData.status === "Escalated to L2" ||
          ticketData.originalData.grievanceTicketMapEntity?.disable === true ||
          ticketData.originalData.accept === false
        : isAdmin === true ||
          ticketData.originalData.grievanceTicketMapEntity.disable === true ||
          ticketData.status === "Resolved" ||
          ticketData.originalData.grievanceTicketMapEntity?.disable !== false;

      const isStatusChanging = currentStatus !== ticketData?.status;
      const isCommentOnlyUpdate =
        !isStatusChanging &&
        comments.length > (ticketData?.originalData?.commentsMap?.length || 0);

      if (hasUserLevel && shouldDisableStatusDropdown && isCommentOnlyUpdate) {
        console.log("Using admin commenting API - comment-only update with disabled status");
        response = await postDataWithFiles(commentingForAdmins, formDataToSend);
      } else {
        console.log("Using status-based API");
        if (currentStatus === "Open") {
          response = await postDataWithFiles(commentingForAdmins, formDataToSend);
        } else if (currentStatus === "In Progress") {
          response = await postDataWithFiles(grievanceInprogress, formDataToSend);
        } else if (currentStatus === "Issue Pending at User Level") {
          response = await postDataWithFiles(grievancePendingUser, formDataToSend);
        } else if (currentStatus === "Issue Pending at External Vendor") {
          response = await postDataWithFiles(grievancePendingExternal, formDataToSend);
        } else if (currentStatus === "Resolved") {
          response = await postDataWithFiles(grievanceResolved, formDataToSend);
        } else if (currentStatus === "Closed") {
          response = await postDataWithFiles(grievanceClosed, formDataToSend);
        } else if (currentStatus === "Rejected") {
          response = await postDataWithFiles(grievanceRejected, formDataToSend);
        }
      }

      if (response.status === "success") {
        toast.success(response.msg || "Grievance updated successfully!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setReassignDescription('');
        setReassignmentRequired(false);
        setReassignmentError('');
        navigate(-1);
      } else {
        throw new Error(response.msg || "Failed to update grievance");
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(error.message || "Failed to update grievance", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const allowedImageTypes = ["image/jpeg", "image/png", "image/gif"];
    const allowedVideoTypes = ["video/mp4"];
    const maxImageSize = 5 * 1024 * 1024;
    const maxVideoSize = 50 * 1024 * 1024;
    const maxFiles = 3;

    const newErrors = [];

    if (selectedImages.length + files.length > maxFiles) {
      newErrors.push(`You can only upload a maximum of ${maxFiles} files.`);
      e.target.value = "";
      setFileErrors(newErrors);
      return;
    }

    const validFiles = [];

    files.forEach((file) => {
      const isVideoType = allowedVideoTypes.includes(file.type);
      const isImageOrPdfType = allowedImageTypes.includes(file.type) || file.type === "application/pdf";

      if (!isVideoType && !isImageOrPdfType) {
        newErrors.push(`File "${file.name}" has an invalid type. Only JPG, PNG, GIF, PDF, and MP4 video are allowed.`);
        return;
      }

      if (isVideoType) {
        if (file.size > maxVideoSize) {
          newErrors.push(`File "${file.name}" exceeds the 50MB limit for videos.`);
          return;
        }
      } else if (file.size > maxImageSize) {
        newErrors.push(`File "${file.name}" exceeds the 5MB limit.`);
        return;
      }

      validFiles.push(file);
    });

    setFileErrors(newErrors);

    validFiles.forEach((file) => {
      if (file.type.startsWith("video/")) {
        setSelectedImages((prevImages) => [
          ...prevImages,
          { file, preview: URL.createObjectURL(file) },
        ]);
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImages((prevImages) => [
          ...prevImages,
          { file, preview: reader.result },
        ]);
      };
      reader.readAsDataURL(file);
    });

    e.target.value = "";
  };

  const isPdf = (file) => {
    return file.type === "application/pdf";
  };

  const isVideo = (file) => {
    return file.type.startsWith("video/");
  };

  const removeImage = (indexToRemove) => {
    setSelectedImages((prevImages) => {
      const removed = prevImages[indexToRemove];
      if (removed && isVideo(removed.file) && removed.preview) {
        URL.revokeObjectURL(removed.preview);
      }
      return prevImages.filter((_, index) => index !== indexToRemove);
    });
  };

  // ─── CHANGE 1: getStatusTransitions simplified to Open → In Progress → Resolved ───
  const getStatusTransitions = (currentStatus) => {
    const status = currentStatus || ticketData?.status;

    switch (status) {
      case "Open":
        return ["In Progress", "Resolved"];
      case "In Progress":
        return ["Resolved"];
      case "Resolved":
        return [];
      case "Closed":
        return [];
      case "Rejected":
        return [];
      default:
        return [];
    }
  };

  useEffect(() => {
    setCurrentStatus(ticketData?.status || "Open");
  }, [ticketData?.status]);

  const currentStep = getCurrentStepIndex();
  console.log(openTransferReasonModal, currentStep);

  const renderProgressTracker = () => {
    const steps = getDynamicSteps(currentStatus, ticketData);

    const getStatusColor = (status) => {
      const statusColors = {
        open: "#D90429",
        "in progress": "#f97316",
        resolved: "#10b981",
        closed: "#304FFE",
        reject: "#ef4444",
        rejected: "#B00020",
      };
      return statusColors[status.toLowerCase()] || "#6b7280";
    };

    const getSegmentColor = (fromStatus, toStatus) => {
      const from = fromStatus.toLowerCase();
      const to = toStatus.toLowerCase();

      if (from === "open" && to === "in progress") return "#D90429";
      else if (from === "in progress" && to === "resolved") return "#f97316";
      else if (to === "reject" || to === "rejected") return "#B00020";
      else return getStatusColor(fromStatus);
    };

    const currentStep = getCurrentStepIndex();

    return (
      <div
        className="mb-3"
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          border: "1px solid #e2e8f0",
          overflow: "hidden",
        }}
      >
        <div style={{ padding: "9px 18px", color: "#2E6DA4", backgroundColor: "#EBF4FA", borderBottom: "1px solid #EEF1F5" }}>
          <h6 style={{ fontSize: "15px", fontWeight: "600", margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-graph-up-arrow" style={{ fontSize: "15px" }}></i>
            Track your Ticket
          </h6>
        </div>

        <div style={{ padding: "14px 24px" }}>
          <div className="position-relative" style={{ height: "50px", marginBottom: "6px", zIndex: 1 }}>
            <div style={{ position: "absolute", height: "4px", backgroundColor: "#f1f5f9", width: "calc(100% - 20px)", left: "10px", top: "9px", zIndex: 1, borderRadius: "2px" }}></div>

            {steps.map((step, segmentIndex) => {
              if (segmentIndex >= steps.length - 1) return null;

              const totalSegments = steps.length - 1;
              const segmentWidth = `calc(${100 / totalSegments}% - ${20 / totalSegments}px)`;
              const segmentLeft = `calc(${(segmentIndex * 100) / totalSegments}% + ${10 - (segmentIndex * 20) / totalSegments}px)`;
              const isActive = segmentIndex < currentStep;

              const fromStatus = steps[segmentIndex];
              const toStatus = steps[segmentIndex + 1];
              const segmentColor = getSegmentColor(fromStatus, toStatus);

              return (
                <div
                  key={`segment-${segmentIndex}`}
                  style={{
                    position: "absolute",
                    height: "4px",
                    backgroundColor: isActive ? segmentColor : "#f1f5f9",
                    width: segmentWidth,
                    left: segmentLeft,
                    top: "9px",
                    zIndex: 2,
                    borderRadius: "2px",
                    transition: "all 0.5s ease-in-out",
                  }}
                ></div>
              );
            })}

            {steps.map((step, index) => {
              const statusColor = getStatusColor(step);
              const isActive = index <= currentStep;
              const isCurrent = index === currentStep;

              const totalSteps = steps.length - 1;
              const leftPosition = index === 0 ? "10px" :
                                   index === steps.length - 1 ? "calc(100% - 10px)" :
                                   `calc(${(index * 100) / totalSteps}% + ${10 - (index * 20) / totalSteps}px)`;
              const translateX = "-50%";

              return (
                <div
                  key={index}
                  className="d-flex flex-column align-items-center position-absolute"
                  style={{ zIndex: 3, left: leftPosition, transform: `translateX(${translateX})`, transition: "all 0.3s ease" }}
                >
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      backgroundColor: isActive ? statusColor : "#e2e8f0",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "12px",
                      transition: "all 0.3s ease",
                      border: isCurrent ? "3px solid #ffffff" : "2px solid #ffffff",
                      boxShadow: isActive ? `0 2px 8px ${statusColor}40` : "0 1px 3px rgba(0, 0, 0, 0.1)",
                      boxSizing: "border-box",
                    }}
                  >
                    {index < currentStep && (
                      <i className="bi bi-check text-white" style={{ fontSize: "12px", fontWeight: "bold", marginLeft: "-20px" }}></i>
                    )}
                    {isCurrent && currentStep !== 0 && (
                      <div style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#ffffff", animation: "pulse 2s infinite" }}></div>
                    )}
                  </div>
                  <span
                    style={{
                      fontSize: "13px",
                      color: isActive ? "#374151" : "#9ca3af",
                      fontWeight: isCurrent ? 600 : 500,
                      textAlign: "center",
                      transition: "color 0.3s ease",
                      maxWidth: "120px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={step}
                  >
                    {step}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        <style jsx>{`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
        `}</style>
      </div>
    );
  };

  const renderAttachmentsSection = () => {
    const shouldShowAttachments = (() => {
      if (isStatusClosedOrRejected || hasActionMessage || userRole === "SUPER ADMIN" || isAdmin === true || supportAdmin === true) {
        return false;
      }
      if (userLevel === "L1") {
        return isL1AndCreator();
      }
      if (userLevel === "L2" || userLevel === "L3") {
        return ticketData?.originalData?.grievanceTicketMapEntity?.disable === false;
      }
      return !isStatusClosedOrRejected && !hasActionMessage;
    })();

    if (!shouldShowAttachments) return null;

    return (
      <div className="mb-3" style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)", border: "1px solid #e2e8f0", overflow: "hidden" }}>
        <div style={{ padding: "9px 18px", color: "#2E6DA4", backgroundColor: "#EBF4FA", borderBottom: "1px solid #EEF1F5" }}>
          <h6 style={{ fontSize: "15px", fontWeight: "600", margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-paperclip" style={{ fontSize: "15px" }}></i>
            Attachments
          </h6>
        </div>

        <div style={{ padding: "10px 14px" }}>
          <div className="border rounded-3 position-relative" style={{ minHeight: "84px", background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)", transition: "all 0.3s ease", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <input type="file" className="d-none" id="attachments" onChange={handleImageChange} multiple accept=".jpg,.jpeg,.png,.gif,.pdf,.mp4" />
            <label htmlFor="attachments" className="mb-0" style={{ cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "14px" }}>
              <i className="bi bi-cloud-upload" style={{ fontSize: "26px", color: "#8b5cf6", marginBottom: "6px" }}></i>
              <div style={{ color: "#2E6DA4", fontSize: "14px", fontWeight: 600 }}>Click here to browse</div>
            </label>

            {selectedImages.length > 0 && (
              <div className="mt-4 d-flex flex-wrap justify-content-center gap-3">
                {selectedImages.map((imgObj, index) => (
                  <div
                    key={index}
                    style={{ position: "relative", display: "inline-block", borderRadius: "10px", overflow: "visible", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)", transition: "transform 0.2s ease" }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  >
                    {isPdf(imgObj.file) ? (
                      <div style={{ width: "100px", height: "100px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)", borderRadius: "10px", border: "2px solid #f87171", padding: "8px" }}>
                        <i className="bi bi-file-earmark-pdf" style={{ fontSize: "28px", color: "#dc2626", marginBottom: "4px" }}></i>
                        <div style={{ fontSize: "10px", textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", width: "100%", color: "#dc2626", fontWeight: "600" }}>{imgObj.file.name}</div>
                      </div>
                    ) : isVideo(imgObj.file) ? (
                      <div style={{ position: "relative", width: "100px", height: "100px" }}>
                        <video src={imgObj.preview} muted playsInline preload="metadata" style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "10px", background: "#000" }} />
                        <i className="bi bi-play-circle-fill" style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", fontSize: "28px", color: "#ffffff", textShadow: "0 1px 4px rgba(0,0,0,0.6)", pointerEvents: "none" }}></i>
                      </div>
                    ) : (
                      <img src={imgObj.preview} alt={`preview-${index}`} style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "10px" }} />
                    )}
                    <button
                      onClick={() => removeImage(index)}
                      style={{ position: "absolute", top: "-10px", right: "-10px", color: "#000000", border: "2px solid #e5e7eb", borderRadius: "50%", width: "24px", height: "24px", cursor: "pointer", fontSize: "12px", display: "flex", alignItems: "center", justifyContent: "center", background: "#f9fafb", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)", transition: "all 0.2s ease", fontWeight: "bold", zIndex: 10 }}
                      title="Remove attachment"
                      onMouseEnter={(e) => { e.currentTarget.style.transform = "scale(1.1)"; e.currentTarget.style.background = "#ef4444"; e.currentTarget.style.color = "white"; e.currentTarget.style.borderColor = "#dc2626"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.background = "#f9fafb"; e.currentTarget.style.color = "#000000"; e.currentTarget.style.borderColor = "#e5e7eb"; }}
                    >
                      <i className="bi bi-x" style={{ fontSize: "14px", lineHeight: "1" }}></i>
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="mt-3 d-flex align-items-center justify-content-between">
            <small style={{ color: "#64748b", fontSize: "13px" }}>
              <i className="bi bi-info-circle me-1"></i>
              Allowed formats: JPG, PNG, GIF, PDF (max 5MB each), MP4 (max 50MB each) — 3 files maximum
            </small>
          </div>

          {fileErrors.length > 0 && (
            <div className="mt-3">
              {fileErrors.map((error, index) => (
                <div key={index} className="alert alert-danger py-2 px-3 mb-2" style={{ fontSize: "13px", borderRadius: "8px", border: "1px solid #fecaca", backgroundColor: "#fef2f2" }}>
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  {error}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderSubmitButtons = () => {
    const isL1Restricted = userLevel === "L1" && !isL1AndCreator();

    const shouldShowSubmitButtons = (() => {
      if (userRole === "Citizen" && ticketData?.status === "Resolved") {
        return false;
      }
      if (isStatusClosedOrRejected || hasActionMessage || isAdmin === true || userRole === "SUPER ADMIN" || supportAdmin === true) {
        return false;
      }
      if (userLevel === "L1") {
        return isL1AndCreator();
      }
      if (userLevel === "L2" || userLevel === "L3") {
        return ticketData?.originalData?.grievanceTicketMapEntity?.disable === false;
      }
      return true;
    })();

    if (!shouldShowSubmitButtons || isL1Restricted) {
      return (
        <div className="d-flex justify-content-center gap-2 mt-2">
          <div style={{ width: "90%", maxWidth: "600px" }}>
            <div className="d-flex justify-content-center">
              <button type="button" className="branch-save-submit-btn btn btn-success" onClick={handleCancel} style={{ marginBottom: "0rem" }}>Back</button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="d-flex justify-content-center gap-2 mt-2">
        <div style={{ width: "90%", maxWidth: "600px" }}>
          {(rootCauseError || commentError || reassignmentError) && (
            <div className="alert alert-danger mb-2" style={{ height: "auto", width: "100%", padding: "0.5rem" }} role="alert">
              {rootCauseError || commentError || reassignmentError}
            </div>
          )}
          <div className="d-flex justify-content-center" style={{ marginTop: "0rem" }}>
            <button type="button" className="branch-save-submit-btn btn btn-success" onClick={handleSubmit} disabled={isSubmitting || isTextFieldDisable} style={{ marginBottom: "0rem" }}>
              {isSubmitting ? "Submitting..." : "Save & Submit"}
            </button>
            <button type="button" className="branch-save-submit-btn btn btn-success" style={{ marginLeft: "15px", marginBottom: "0rem" }} onClick={handleCancel}>Cancel</button>
          </div>
        </div>
      </div>
    );
  };

  const renderCommentsSection = () => {
    return (
      <div className="mb-3" style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)", border: "1px solid #e2e8f0", overflow: "hidden" }}>
        <div style={{ padding: "9px 18px", color: "#2E6DA4", backgroundColor: "#EBF4FA", borderBottom: "1px solid #EEF1F5" }}>
          <h6 style={{ fontSize: "15px", fontWeight: "600", margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-chat-dots" style={{ fontSize: "15px" }}></i>
            Comments
          </h6>
        </div>

        <div style={{ padding: "10px 14px" }}>
          <div className="comments-list mb-4">
            {comments.length > 0 ? (
              comments.map((comment) => (
                <div key={comment.id} className="d-flex mb-4 p-3" style={{ backgroundColor: "#f8fafc", borderRadius: "12px", border: "1px solid #e2e8f0" }}>
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ width: "40px", height: "40px", borderRadius: "50%", background: "#2E6DA4", color: "white", marginRight: "16px", flexShrink: 0, fontSize: "12px", fontWeight: "600", cursor: 'pointer', transition: 'all 0.2s ease' }}
                    onClick={(e) => handleAvatarInteraction(comment, e, 'click')}
                    onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(72, 153, 183, 0.4)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = 'none'; }}
                    title="Click to view user details"
                  >
                    {comment.avatar}
                  </div>
                  <div className="flex-grow-1">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div style={{ fontWeight: "600", fontSize: "12px", color: "#1e293b" }}>{comment.user}</div>
                      <div style={{ fontSize: "12px", color: "#64748b", backgroundColor: "#f1f5f9", borderRadius: "6px" }}>{comment.date}</div>
                    </div>
                    <div style={{ color: "#475569", marginTop: "-8px", fontSize: "14px", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                      {comment.text}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-2" style={{ background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)", borderRadius: "12px", border: "2px dashed #cbd5e1" }}>
                <p className="text-muted mt-3 mb-2" style={{ fontSize: "14px", fontWeight: "500" }}>No comments available</p>
              </div>
            )}
          </div>

          {(() => {
            const shouldShowCommentInput = (() => {
              if (userRole === "Citizen") {
                return !isStatusClosedOrRejected && ticketData?.status !== "Resolved";
              }
              if (isStatusClosedOrRejected || hasActionMessage || isAdmin === true || userRole === "SUPER ADMIN" || supportAdmin === true) {
                return false;
              }
              if (userLevel === "L1") {
                return isL1AndCreator();
              }
              if (userLevel === "L2" || userLevel === "L3") {
                return ticketData?.originalData?.grievanceTicketMapEntity?.disable === false;
              }
              return true;
            })();

            return shouldShowCommentInput ? (
              <div className="d-flex">
                <div className="d-flex justify-content-center align-items-center" style={{ width: "40px", height: "40px", borderRadius: "50%", background: "#2E6DA4", color: "white", marginRight: "14px", flexShrink: 0 }}>
                  <FaUser size={18} />
                </div>
                <div className="position-relative flex-grow-1" style={{ borderRadius: "12px", overflow: "hidden", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}>
                  <textarea
                    id="commentTextarea"
                    placeholder={reassignmentPrefix ? "" : "Write your comment here..."}
                    value={comment}
                    onChange={(e) => {
                      const inputText = e.target.value;
                      if (reassignmentPrefix) {
                        if (!inputText.startsWith(reassignmentPrefix + '\n\n')) {
                          setComment(reassignmentPrefix + '\n\n');
                          return;
                        }
                      }
                      if (inputText.replace(/[^a-zA-Z]/g, "").length <= 500) {
                        setComment(inputText);
                        if (commentError && inputText.trim()) setCommentError("");
                      }
                    }}
                    onKeyDown={(e) => {
                      if (reassignmentPrefix) {
                        const textarea = e.target;
                        const selectionStart = textarea.selectionStart;
                        const selectionEnd = textarea.selectionEnd;
                        const prefixLength = reassignmentPrefix.length + 2;

                        if (e.key === 'Backspace' || e.key === 'Delete') {
                          if (selectionStart !== selectionEnd) {
                            if (selectionStart < prefixLength) {
                              e.preventDefault();
                              if (selectionEnd > prefixLength) {
                                const textBeforePrefix = comment.substring(0, prefixLength);
                                const textAfterSelection = comment.substring(selectionEnd);
                                setComment(textBeforePrefix + textAfterSelection);
                                setTimeout(() => { textarea.setSelectionRange(prefixLength, prefixLength); }, 0);
                              } else {
                                setTimeout(() => { textarea.setSelectionRange(prefixLength, prefixLength); }, 0);
                              }
                            }
                          } else {
                            if (selectionStart <= prefixLength) {
                              e.preventDefault();
                              textarea.setSelectionRange(prefixLength, prefixLength);
                            }
                          }
                        }
                      }
                    }}
                    onClick={(e) => {
                      if (reassignmentPrefix) {
                        const cursorPosition = e.target.selectionStart;
                        const prefixLength = reassignmentPrefix.length + 2;
                        if (cursorPosition < prefixLength) {
                          setTimeout(() => { e.target.setSelectionRange(prefixLength, prefixLength); }, 0);
                        }
                      }
                    }}
                    onFocus={(e) => {
                      if (reassignmentPrefix) {
                        setTimeout(() => {
                          const prefixLength = reassignmentPrefix.length + 2;
                          e.target.setSelectionRange(prefixLength, prefixLength);
                        }, 0);
                      }
                    }}
                    className="form-control"
                    style={{
                      border: comment.replace(/[^a-zA-Z]/g, "").length >= 500 ? "1px solid #ef4444" : "1px solid #d1d5db",
                      backgroundColor: "#ffffff",
                      minHeight: reassignmentPrefix ? "120px" : "80px",
                      borderRadius: "12px 12px 0 0",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      padding: "16px",
                    }}
                  />
                  <div className="d-flex justify-content-between align-items-center px-4 py-3" style={{ backgroundColor: "#f8fafc", borderTop: "1px solid #e5e7eb" }}>
                    <div style={{ fontSize: "12px", color: comment.replace(/[^a-zA-Z]/g, "").length >= 500 ? "#ef4444" : "#64748b", fontWeight: "500", marginLeft: "0px" }}>
                      <i className="bi"></i>
                      {comment.replace(/[^a-zA-Z]/g, "").length}/500 characters
                      {comment.replace(/[^a-zA-Z]/g, "").length >= 500 && (
                        <span className="ms-2 text-danger">
                          <i className="bi bi-exclamation-triangle me-1"></i>
                          Character limit reached
                        </span>
                      )}
                    </div>
                    <button
                      onClick={handleCommentSubmit}
                      style={{ background: "#2E6DA4", border: "none", borderRadius: "8px", cursor: "pointer", padding: "8px 16px", color: "white", fontSize: "10px", fontWeight: "500", boxShadow: "0 2px 8px rgba(16, 185, 129, 0.3)", transition: "all 0.2s ease" }}
                      onMouseEnter={(e) => { e.currentTarget.style.transform = "scale(1.05)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(16, 185, 129, 0.4)"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0 2px 8px rgba(16, 185, 129, 0.3)"; }}
                    >
                      <Send size={16} className="me-1" />
                    </button>
                  </div>
                </div>
              </div>
            ) : null;
          })()}
        </div>
      </div>
    );
  };

  const renderTicketView = () => {
    if (!ticketData) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
          <div className="text-center text-muted">
            <div className="spinner-border mb-3" style={{ color: "#2E6DA4" }} role="status" />
            <p style={{ fontSize: "14px" }}>Loading ticket details...</p>
          </div>
        </div>
      );
    }

    // eslint-disable-next-line no-unused-vars
    const transitions = getStatusTransitions(currentStatus);

    return (
      <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
        <div className="incv-header-banner">
          <button type="button" className="incv-back-btn" onClick={() => navigate(-1)} aria-label="Back">
            <ArrowLeft size={16} />
          </button>
          <span className="incv-header-icon">
            <MessageSquareWarning size={14} color="#fff" />
          </span>
          <div>
            <div className="incv-header-title">Grievance Details</div>
            <div className="incv-header-subtitle">Ticket #{displayData(ticketData?.id)} — action desk and activity history</div>
          </div>
        </div>
      <div className="container-fluid p-0" style={{ backgroundColor: "#f8fafc", marginTop: "12px" }}>
        <Loader show={loader} type="body" stack="vertical" message="Loading Data" />
        <div className="row g-0">
          <div className="col-md-12 p-3">
            <div key={currentStatus}>
              {renderProgressTracker()}
            </div>

            {/* Grievance Information Card */}
            <div className="mb-3" style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)", border: "1px solid #e2e8f0", overflow: "hidden" }}>
              <div
                className="incv-card-header--clickable"
                style={{ padding: "9px 18px", color: "#2E6DA4", backgroundColor: "#EBF4FA", borderBottom: "1px solid #EEF1F5", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                onClick={() => setIsGrievanceInfoExpanded((prev) => !prev)}
              >
                <h6 style={{ fontSize: "15px", fontWeight: "600", margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
                  <i className="bi bi-ticket-detailed" style={{ fontSize: "15px" }}></i>
                  Grievance Information
                </h6>
                <i
                  className={`bi bi-chevron-down incv-chevron${isGrievanceInfoExpanded ? " incv-chevron--open" : ""}`}
                  style={{ fontSize: "13px" }}
                ></i>
              </div>

              {isGrievanceInfoExpanded && (
              <div style={{ padding: "10px 14px" }}>
                {/* ─── CHANGE 5: Removed Bank Name, Branch Name, Support Team ─── */}
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "6px", marginBottom: "4px" }}>
                  <div style={{ padding: "6px 8px" }}>
                    <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Grievance ID</p>
                    <p className="mb-0" style={{ fontWeight: "600", fontSize: "14px", color: "#1e293b" }}>{displayData(ticketData?.id)}</p>
                  </div>

                  <div style={{ padding: "6px 8px" }}>
                    <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Subject</p>
                    <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b" }}>{displayData(ticketData?.subject)}</p>
                  </div>

                  <div style={{ padding: "6px 8px" }}>
                    <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Ticket Created Date & Time</p>
                    <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b" }}>{displayData(ticketData?.date)}</p>
                  </div>

                  <div style={{ padding: "6px 8px" }}>
                    <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Priority</p>
                    <div className="mb-0">
                      <span style={{ color: "#1e293b", fontWeight: "600", fontSize: "14px" }}>{ticketData?.criticality || "N/A"}</span>
                    </div>
                  </div>

                  <div style={{ padding: "6px 8px" }}>
                    <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Category</p>
                    <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b" }}>{displayData(ticketData?.type)}</p>
                  </div>

                  <div style={{ padding: "6px 8px" }}>
                    <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Subcategory</p>
                    <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b" }}>{displayData(ticketData?.issueTypeSubCatName)}</p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div style={{ padding: "6px 8px" }}>
                      <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Description</p>
                      <div className="mb-0 ticket-description" style={{ fontSize: "14px", lineHeight: "1.6", color: "#334155" }} dangerouslySetInnerHTML={{ __html: ticketData?.originalData.description || ticketData?.details || "N/A" }} />
                    </div>
                  </div>
                </div>

                {/* Action Desk Card */}
                <div className="mb-3" style={{ backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
                  <div style={{ background: '#EBF4FA', padding: '9px 18px', color: '#2E6DA4', borderBottom: '1px solid #EEF1F5' }}>
                    <h6 style={{ fontSize: '15px', fontWeight: '600', margin: '0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <i className="bi bi-gear" style={{ fontSize: '15px' }}></i>
                      Action Desk
                    </h6>
                  </div>

                  <div className="row">
                    <div className="col-6">
                      <div style={{ padding: "6px 8px" }}>
                        <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Status</p>
                        <div className="mb-0" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                          {(() => {
                            const hasUserLevel = userLevel !== null && userLevel !== undefined;
                            // eslint-disable-next-line no-unused-vars
                            const currentUserId = user;

                            const isL1OpenUnassigned =
                              userLevel === "L1" &&
                              ticketData?.status === "Open" &&
                              (ticketData?.originalData?.assignToUserName === "Unassigned");

                            const shouldDisableDropdown = userRole === "Citizen"
                              ? true
                              : hasUserLevel
                              ? isL1OpenUnassigned
                                ? false
                                : ticketData.originalData.reopenDisable === true ||
                                  hasActionMessage ||
                                  userRole === "SUPER ADMIN" ||
                                  isAdmin === true ||
                                  ticketData.status === "Escalated to L2" ||
                                  ticketData.originalData.grievanceTicketMapEntity?.disable === true ||
                                  supportAdmin === true ||
                                  (userLevel === "L1" && (ticketData.originalData.grievanceTicketMapEntity?.disable === true)) ||
                                  (userLevel === "L2" && (ticketData.originalData.grievanceTicketMapEntity?.disable === true)) ||
                                  false
                              : isAdmin === true || supportAdmin === true || isStatusClosedOrRejected || userRole === "SUPER ADMIN" ||
                                ticketData.status === "Resolved" ||
                                ticketData.originalData.grievanceTicketMapEntity?.disable !== false;

                            return (
                              <>
                                {shouldDisableDropdown ? (
                                  <div style={{ display: "flex", alignItems: "left", gap: "1px" }}>
                                    <div style={{
                                      fontWeight: "600",
                                      color: currentStatus === "Open" ? "#D90429" : currentStatus === "Closed" ? "#304FFE" : currentStatus === "In Progress" ? "#FF7F11" : currentStatus === "Resolved" ? "#228B22" : currentStatus === "Rejected" ? "#B00020" : "#6b7280",
                                      fontSize: "14px",
                                      padding: "6px 12px",
                                      backgroundColor: currentStatus === "Open" ? "#FDE2E4" : currentStatus === "Closed" ? "#E0E8F9" : currentStatus === "In Progress" ? "#FFF1E6" : currentStatus === "Resolved" ? "#E2F0CB" : currentStatus === "Rejected" ? "#FBE3E8" : "#f9fafb",
                                      borderRadius: "8px",
                                      display: "inline-block",
                                    }}>
                                      {currentStatus}
                                    </div>
                                    {ticketData.originalData.reopenDisable === true && currentStatus === "Closed" && (
                                      <span style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }} title="This ticket can't be reopened because 36 hours have passed since closure. Please raise a new ticket if needed.">
                                        <i className="fas fa-info-circle" style={{ fontSize: "14px", color: "#6b7280", marginLeft: "-22px" }} />
                                      </span>
                                    )}
                                  </div>
                                ) : (
                                  <select
                                    id="statusDropdown"
                                    className="form-select"
                                    style={{ display: "inline-block", width: "273px", minWidth: "150px", maxWidth: "100%", borderColor: "black", borderRadius: "8px", padding: "8px 12px", fontSize: "14px", backgroundColor: "white", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", fontWeight: "500" }}
                                    value={currentStatus}
                                    onChange={handleStatusChange}
                                  >
                                    {(() => {
                                      if (isL1OpenUnassigned) {
                                        return (
                                          <>
                                            <option value="Open">Open</option>
                                            <option value="Closed">Closed</option>
                                          </>
                                        );
                                      }

                                      // ─── CHANGE 4: Simplified filteredOptions ───
                                      let filteredOptions = initialStatusOptions.filter((option) => {
                                        if (userLevel === "L1" &&
                                            ticketData?.originalData?.grievanceTicketMapEntity?.disable === false) {
                                          if (ticketData?.originalData?.status === 838 || currentStatus === "In Progress") {
                                            return ['In Progress', 'Resolved'].includes(option);
                                          }
                                          if (ticketData?.originalData?.status === 840 || currentStatus === "Resolved") {
                                            return option === "Resolved";
                                          }
                                        }
                                        return ['Open', 'In Progress', 'Resolved'].includes(option);
                                      });

                                      return filteredOptions.map((option) => (
                                        <option key={option} value={option}>{option}</option>
                                      ));
                                    })()}
                                  </select>
                                )}
                              </>
                            );
                          })()}
                          {statusError && <div className="text-danger small mt-2" style={{ fontSize: "12px" }}>{statusError}</div>}
                        </div>
                      </div>
                    </div>

                    <div className="col-6">
                      <div style={{ padding: "6px 8px" }}>
                        <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>
                          Action Taken
                        </p>
                        <div className="mb-0">
                          {(() => {
                            const hasUserLevel = userLevel !== null && userLevel !== undefined;
                            // eslint-disable-next-line no-unused-vars
                            const currentUserId = user;
                            const shouldDisableDropdown = hasUserLevel
                              ? isStatusClosedOrRejected || hasActionMessage || userRole === "SUPER ADMIN" || isAdmin === true || ticketData.status === "Escalated to L2" || ticketData.originalData.grievanceTicketMapEntity?.disable === true || supportAdmin === true ||
                                (userLevel === "L1" && (ticketData.originalData.grievanceTicketMapEntity?.disable === true)) ||
                                (userLevel === "L2" && (ticketData.originalData.grievanceTicketMapEntity?.disable === true)) ||
                                false
                              : isAdmin === true || supportAdmin === true || isStatusClosedOrRejected || userRole === "SUPER ADMIN" || ticketData.status === "Resolved" || ticketData.originalData.grievanceTicketMapEntity?.disable !== false;

                            return shouldDisableDropdown ? (
                              <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b", padding: "8px 12px", backgroundColor: "#f8f9fa", borderRadius: "8px", minHeight: "47px" }}>{actionTaken || "N/A"}</p>
                            ) : (
                              <>
                                <textarea className="form-control" style={{ width: "100%", height: "47px", borderColor: "black", borderRadius: "8px", padding: "8px 12px", fontSize: "14px", backgroundColor: "white", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", fontWeight: "500" }} placeholder="action taken..." value={actionTaken} onChange={(e) => setActionTaken(e.target.value)} disabled={isActionTakenDisabled} maxLength={250} />
                                <div className="text-end" style={{ fontSize: "11px", color: "#64748b", marginTop: "2px" }}>{actionTaken.length}/250</div>
                              </>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6">
                      <div style={{ padding: "6px 8px" }}>
                        <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>
                          Root Cause
                          {currentStatus === "Resolved" && <span style={{ color: "#dc2626", fontSize: "11px", fontWeight: "normal" }}> *</span>}
                        </p>
                        <div className="mb-0">
                          {(() => {
                            const hasUserLevel = userLevel !== null && userLevel !== undefined;
                            // eslint-disable-next-line no-unused-vars
                            const currentUserId = user;
                            const shouldDisableDropdown = hasUserLevel
                              ? isStatusClosedOrRejected || hasActionMessage || userRole === "SUPER ADMIN" || isAdmin === true || ticketData.status === "Escalated to L2" || ticketData.originalData.grievanceTicketMapEntity?.disable === true || supportAdmin === true ||
                                (userLevel === "L1" && (ticketData.originalData.grievanceTicketMapEntity?.disable === true)) ||
                                (userLevel === "L2" && (ticketData.originalData.grievanceTicketMapEntity?.disable === true)) ||
                                false
                              : isAdmin === true || supportAdmin === true || ticketData.status === "Resolved" || isStatusClosedOrRejected || userRole === "SUPER ADMIN" || ticketData.originalData.grievanceTicketMapEntity?.disable !== false;

                            return shouldDisableDropdown ? (
                              <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b", padding: "8px 12px", backgroundColor: "#f8f9fa", borderRadius: "8px", minHeight: "47px" }}>{rootCause || "N/A"}</p>
                            ) : (
                              <>
                                <textarea
                                  className="form-control"
                                  style={{ width: "100%", height: "47px", borderColor: !rootCause.trim() && currentStatus === "Resolved" ? "#dc2626" : "black", borderRadius: "8px", padding: "8px 12px", fontSize: "14px", backgroundColor: "white", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", fontWeight: "500" }}
                                  placeholder="root cause..."
                                  value={rootCause}
                                  onChange={(e) => { setRootCause(e.target.value); if (rootCauseError) setRootCauseError(""); }}
                                  disabled={isRootCauseDisabled}
                                  required={currentStatus !== "Open" && currentStatus !== "Resolved"}
                                  maxLength={250}
                                />
                                <div className="text-end" style={{ fontSize: "11px", color: "#64748b", marginTop: "2px" }}>{rootCause.length}/250</div>
                                {rootCauseError && (
                                  <div className="text-danger small mt-2" style={{ fontSize: "12px", display: "flex", alignItems: "center", gap: "4px" }}>
                                    <i className="bi bi-exclamation-triangle"></i>
                                    {rootCauseError}
                                  </div>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      </div>
                    </div>

                    <div className="col-6">
                      <div style={{ padding: "6px 8px" }}>
                        <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Workaround/Resolution Steps</p>
                        <div className="mb-0">
                          {(() => {
                            const hasUserLevel = userLevel !== null && userLevel !== undefined;
                            // eslint-disable-next-line no-unused-vars
                            const currentUserId = user;
                            const shouldDisableDropdown = hasUserLevel
                              ? isStatusClosedOrRejected || hasActionMessage || userRole === "SUPER ADMIN" || isAdmin === true || ticketData.status === "Escalated to L2" || ticketData.originalData.grievanceTicketMapEntity?.disable === true || supportAdmin === true ||
                                (userLevel === "L1" && (ticketData.originalData.grievanceTicketMapEntity?.disable === true)) ||
                                (userLevel === "L2" && (ticketData.originalData.grievanceTicketMapEntity?.disable === true)) ||
                                false
                              : isAdmin === true || supportAdmin === true || ticketData.status === "Resolved" || isStatusClosedOrRejected || userRole === "SUPER ADMIN" || ticketData.originalData.grievanceTicketMapEntity?.disable !== false;

                            return shouldDisableDropdown ? (
                              <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b", padding: "8px 12px", backgroundColor: "#f8f9fa", borderRadius: "8px", minHeight: "47px" }}>{resolutionSteps || "N/A"}</p>
                            ) : (
                              <>
                                <textarea className="form-control" style={{ width: "100%", height: "47px", borderColor: "black", borderRadius: "8px", padding: "8px 12px", fontSize: "14px", backgroundColor: "white", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", fontWeight: "500" }} placeholder="workaround/resolution steps..." value={resolutionSteps} onChange={(e) => setResolutionSteps(e.target.value)} disabled={isResolutionStepsDisabled} maxLength={250} />
                                <div className="text-end" style={{ fontSize: "11px", color: "#64748b", marginTop: "2px" }}>{resolutionSteps.length}/250</div>
                              </>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>

                  {reassignmentDescription && (
                    <div className="row">
                      <div className="col-12">
                        <div style={{ padding: "6px 8px" }}>
                          <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Resolved Description</p>
                          <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b", padding: "8px 12px", backgroundColor: "#f8f9fa", borderRadius: "8px", minHeight: "47px" }}>{reassignmentDescription}</p>
                        </div>
                      </div>
                    </div>
                  )}

                  {assignmentDescription && (
                    <div className="row">
                      <div className="col-12">
                        <div style={{ padding: "6px 8px" }}>
                          <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Assignment Description</p>
                          <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b", padding: "8px 12px", backgroundColor: "#f8f9fa", borderRadius: "8px", minHeight: "47px" }}>{assignmentDescription}</p>
                        </div>
                      </div>
                    </div>
                  )}

                  {l2AssignmentDescription && (
                    <div className="row">
                      <div className="col-12">
                        <div style={{ padding: "6px 8px" }}>
                          <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>L2 Assignment Description</p>
                          <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b", padding: "8px 12px", backgroundColor: "#f8f9fa", borderRadius: "8px", minHeight: "47px" }}>{l2AssignmentDescription}</p>
                        </div>
                      </div>
                    </div>
                  )}

                  {ticketData?.originalData?.grievanceTicketMapEntity?.actionMessage && (
                    <div className="row">
                      <div className="col-12">
                        <div style={{ padding: "6px 8px" }}>
                          <p className="mb-2" style={{ color: '#98A2B3', fontSize: '9.5px', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase' }}>Action Message</p>
                          <div className="mb-0">
                            <p className="mb-0" style={{ fontWeight: 500, fontSize: '14px', color: '#1e293b', padding: '8px 0px', backgroundColor: 'transparent', borderRadius: '8px', minHeight: 'auto' }}>
                              {ticketData.originalData.grievanceTicketMapEntity.actionMessage}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {hasActionMessage && (
                    <div style={{ padding: "6px 8px" }}>
                      <p className="mb-2" style={{ color: "#92400e", fontSize: "12px", fontWeight: "600", letterSpacing: "0.5px" }}>Action Message</p>
                      <div className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#92400e" }}>
                        {ticketData?.originalData?.grievanceTicketMapEntity?.actionMessage}
                      </div>
                    </div>
                  )}

                  {userLevel && (
                    <div className="row">
                      <div className="col-6">
                        <div style={{ padding: "6px 8px" }}>
                          {userLevel !== "L1" && (
                            <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Action Type</p>
                          )}
                          <div style={{ display: "flex" }}>
                            <div className="mb-0" style={{ width: isStatusClosedOrRejected || hasActionMessage || userRole === "SUPER ADMIN" || isAdmin === true || ticketData.originalData.grievanceTicketMapEntity.disable === true || userLevel !== ticketData.originalData.userLevel || currentStatus === "Issue Pending at User Level" || currentStatus === "Issue Pending at External Vendor" ? "68%" : "46%" }}>
                              {isStatusClosedOrRejected || hasActionMessage || userRole === "SUPER ADMIN" || isAdmin === true || ticketData.originalData.grievanceTicketMapEntity.disable === true || userLevel !== ticketData.originalData.userLevel || currentStatus === "Issue Pending at User Level" || currentStatus === "Issue Pending at External Vendor" ? (
                                <>
                                  <div style={{ display: "flex" }}>
                                    {userLevel !== "L1" && (
                                      <select className="form-select" style={{ borderColor: "black", borderRadius: "8px", fontSize: "14px", backgroundColor: "#f8f9fa", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", fontWeight: "500", opacity: 0.4, color: "#666" }} disabled={true} value="">
                                        {(() => {
                                          const hasManualEscalateRemarks1 = ticketData?.originalData?.escalateRemarks1 && !ticketData?.originalData?.escalateRemarks1.toLowerCase().includes('auto-escalated');
                                          const hasManualEscalateRemarks2 = ticketData?.originalData?.escalateRemarks2 && !ticketData?.originalData?.escalateRemarks2.toLowerCase().includes('auto-escalated');
                                          const hasManualEscalateRemarks3 = ticketData?.originalData?.escalateRemarks3 && !ticketData?.originalData?.escalateRemarks3.toLowerCase().includes('auto-escalated');
                                          const manualEscalationDone = hasManualEscalateRemarks1 || hasManualEscalateRemarks2 || hasManualEscalateRemarks3;
                                          if (manualEscalationDone) {
                                            return <option value="manual">Manual Escalation</option>;
                                          }
                                          return (<option value="manual">Manual Escalation</option>);
                                        })()}
                                      </select>
                                    )}
                                    <div style={{ width: "150%" }}>
                                      <p className="mb-2" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", marginTop: "-24px", marginLeft: userLevel === "L1" ? "2px" : "67px" }}>Escalation Level</p>
                                      <div className="mb-0">
                                        <p className="mb-0" style={{ fontWeight: 500, fontSize: "14px", color: "#1e293b", padding: "8px 0px", backgroundColor: "transparent", borderRadius: "8px", minHeight: "auto", marginLeft: userLevel === "L1" ? "12px" : "110px" }}>
                                          {ticketData.originalData.userLevel ? `${ticketData.originalData.userLevel}` : "NA"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <select
                                  id="escalationType"
                                  className="form-select"
                                  style={{ borderColor: "black", borderRadius: "8px", fontSize: "14px", backgroundColor: "white", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", fontWeight: "500" }}
                                  value={escalationType}
                                  onChange={(e) => {
                                    const newValue = e.target.value;
                                    setEscalationType(newValue);
                                    if (newValue === 'manual') {
                                      setShowManualEscalationWarning(true);
                                    } else {
                                      setShowManualEscalationWarning(false);
                                    }
                                  }}
                                >
                                  {(() => {
                                    const hasManualEscalateRemarks1 = ticketData?.originalData?.escalateRemarks1 && !ticketData?.originalData?.escalateRemarks1.toLowerCase().includes('auto-escalated');
                                    const hasManualEscalateRemarks2 = ticketData?.originalData?.escalateRemarks2 && !ticketData?.originalData?.escalateRemarks2.toLowerCase().includes('auto-escalated');
                                    const hasManualEscalateRemarks3 = ticketData?.originalData?.escalateRemarks3 && !ticketData?.originalData?.escalateRemarks3.toLowerCase().includes('auto-escalated');
                                    const manualEscalationDone = hasManualEscalateRemarks1 || hasManualEscalateRemarks2 || hasManualEscalateRemarks3;
                                    if (manualEscalationDone) {
                                      return <option value="manual">Manual Escalation</option>;
                                    }
                                    return (<option value="manual">Manual Escalation</option>);
                                  })()}
                                </select>
                              )}

                              {showManualEscalationWarning && userRole !== "Citizen" && ticketData?.status !== "Resolved" && !((userLevel === "L2" || userLevel === "L3") && ticketData.originalData.grievanceTicketMapEntity?.disable === true) && (
                                <div className="alert alert-info mt-2 mb-0" style={{ backgroundColor: '#E8F4F8', border: '1px solid #2E6DA4', borderRadius: '8px', padding: '10px 12px', display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '13px' }}>
                                  <i className="bi bi-info-circle" style={{ fontSize: '16px', color: '#2E6DA4', marginTop: '2px', flexShrink: 0 }}></i>
                                  <div style={{ flex: 1, color: '#1e293b' }}>
                                    <strong style={{ display: 'block', marginBottom: '4px' }}>Important:</strong>
                                    Once Manual Escalation is selected, the action will not revert to Auto Escalation.
                                  </div>
                                </div>
                              )}
                            </div>

                            <div>
                              {escalationType === "manual" && (
                                <div style={{ padding: "16px", paddingTop: "0" }}>
                                  <div className="mb-0">
                                    {isStatusClosedOrRejected || hasActionMessage || userRole === "SUPER ADMIN" || isAdmin === true || ticketData.originalData.grievanceTicketMapEntity.disable === true || userLevel !== ticketData.originalData.userLevel || currentStatus === "Issue Pending at User Level" || currentStatus === "Issue Pending at External Vendor" ? (
                                      <p></p>
                                    ) : (
                                      <select
                                        id="escalationLevel"
                                        className="form-select"
                                        style={{ borderColor: "black", borderRadius: "8px", fontSize: "14px", backgroundColor: "white", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", fontWeight: "500" }}
                                        value={escalationLevel || ""}
                                        onChange={onEscalationLevelChange}
                                      >
                                        <option value="">Select Level</option>
                                        {userLevel === "L1" && <option value="L2">L2</option>}
                                        {userLevel === "L2" && <option value="L3">L3</option>}
                                        {userLevel === "L3" && <option value="L2">L2</option>}
                                      </select>
                                    )}

                                    {showEscalationModal && (
                                      <Modal show={showEscalationModal} onHide={handleEscalationModalClose} centered>
                                        <Modal.Header closeButton>
                                          <Modal.Title>Escalate to {escalationLevel}</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                          <div className="form-group">
                                            <label htmlFor="escalationComment" className="form-label">
                                              Escalation Remarks <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                              id="escalationComment"
                                              className="form-control"
                                              rows="4"
                                              value={escalationComment}
                                              onChange={(e) => { const inputValue = e.target.value; if (inputValue.length <= 250) { setEscalationComment(inputValue); } }}
                                              placeholder="Please provide details for escalating this ticket..."
                                              maxLength={250}
                                            />
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "4px" }}>
                                              <div style={{ fontSize: "11px", color: "#666", display: "flex", alignItems: "center", gap: "4px" }}>Escalation Remarks is required</div>
                                              <div style={{ fontSize: "11px" }}>
                                                <span className={`text-${escalationComment.length > 250 ? 'danger' : 'muted'}`}>{escalationComment.length}/250 characters</span>
                                              </div>
                                            </div>
                                          </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                          <Button variant="secondary" onClick={handleEscalationModalClose}>Cancel</Button>
                                          <Button variant="primary" onClick={submitEscalation} disabled={escalationComment.trim() === "" || isSubmittingEscalation} className="custom-escalation-btn">Submit</Button>
                                        </Modal.Footer>
                                      </Modal>
                                    )}
                                  </div>
                                </div>
                              )}

                              {showReassignModal && (
                                <Modal show={showReassignModal} onHide={handleReassignModalClose} centered size="lg">
                                  <Modal.Header closeButton style={{ border: "none", padding: "14px 20px 8px 20px" }}>
                                    <Modal.Title style={{ fontSize: "15px", fontWeight: "700", color: "#1a1a2e", fontFamily: "Poppins, sans-serif" }}>
                                      Complaint Details – {ticketData?.id || "N/A"}
                                    </Modal.Title>
                                  </Modal.Header>
                                  <div style={{ height: "1px", backgroundColor: "#E5E7EB", margin: "0 20px" }} />
                                  <Modal.Body style={{ padding: "14px 20px", fontFamily: "Poppins, sans-serif" }}>
                                    {/* Info Grid */}
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 16px", marginBottom: "12px" }}>
                                      <div>
                                        <div style={{ fontSize: "10px", color: "#9CA3AF", fontWeight: "500", marginBottom: "2px" }}>Region</div>
                                        <div style={{ fontSize: "12px", fontWeight: "600", color: "#111827" }}>{ticketData?.regionName || ticketData?.bank || "N/A"}</div>
                                      </div>
                                      <div>
                                        <div style={{ fontSize: "10px", color: "#9CA3AF", fontWeight: "500", marginBottom: "2px" }}>Reported By</div>
                                        <div style={{ fontSize: "12px", fontWeight: "600", color: "#111827" }}>{ticketData?.requesterBy || "N/A"}</div>
                                      </div>
                                      <div>
                                        <div style={{ fontSize: "10px", color: "#9CA3AF", fontWeight: "500", marginBottom: "2px" }}>Assigned To</div>
                                        <div style={{ fontSize: "12px", fontWeight: "600", color: (!ticketData?.assignToUserName || ticketData?.assignToUserName === "Unassigned") ? "#2563EB" : "#111827" }}>
                                          {ticketData?.assignToUserName || "Unassigned"}
                                        </div>
                                      </div>
                                      <div>
                                        <div style={{ fontSize: "10px", color: "#9CA3AF", fontWeight: "500", marginBottom: "2px" }}>Resolved By</div>
                                        <div style={{ fontSize: "12px", fontWeight: "600", color: "#111827" }}>{ticketData?.resolvedBy || "Not Yet Resolved"}</div>
                                      </div>
                                      <div>
                                        <div style={{ fontSize: "10px", color: "#9CA3AF", fontWeight: "500", marginBottom: "2px" }}>Category</div>
                                        <div style={{ fontSize: "12px", fontWeight: "600", color: "#111827" }}>{ticketData?.issueTypeName || "N/A"}</div>
                                      </div>
                                      <div>
                                        <div style={{ fontSize: "10px", color: "#9CA3AF", fontWeight: "500", marginBottom: "2px" }}>Sub Category</div>
                                        <div style={{ fontSize: "12px", fontWeight: "600", color: "#111827" }}>{ticketData?.issueTypeSubCatName || "N/A"}</div>
                                      </div>
                                      <div>
                                        <div style={{ fontSize: "10px", color: "#9CA3AF", fontWeight: "500", marginBottom: "2px" }}>Created At</div>
                                        <div style={{ fontSize: "12px", fontWeight: "600", color: "#111827" }}>{displayData(ticketData?.date) || "N/A"}</div>
                                      </div>
                                      <div>
                                        <div style={{ fontSize: "10px", color: "#9CA3AF", fontWeight: "500", marginBottom: "2px" }}>Last Updated</div>
                                        <div style={{ fontSize: "12px", fontWeight: "600", color: "#111827" }}>{formatReopenedDateTime(ticketData?.originalData?.updated_on)}</div>
                                      </div>
                                    </div>

                                    {/* Divider */}
                                    <div style={{ height: "1px", backgroundColor: "#E5E7EB", marginBottom: "12px" }} />

                                    {/* Description (read-only) */}
                                    <div style={{ marginBottom: "12px" }}>
                                      <div style={{ fontSize: "12px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>Description</div>
                                      <div
                                        style={{ padding: "8px 12px", backgroundColor: "#F3F4F6", borderRadius: "6px", fontSize: "12px", color: "#374151", lineHeight: "1.5", border: "1px solid #E5E7EB" }}
                                        dangerouslySetInnerHTML={{ __html: ticketData?.originalData?.description || ticketData?.details || "N/A" }}
                                      />
                                    </div>

                                    {/* Divider */}
                                    <div style={{ height: "1px", backgroundColor: "#E5E7EB", marginBottom: "12px" }} />

                                    {/* Resolution Notes */}
                                    <div>
                                      <div style={{ fontSize: "12px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>Resolution Notes</div>
                                      <textarea
                                        id="reassignDescription"
                                        rows="3"
                                        value={tempReassignDescription}
                                        onChange={(e) => { const inputValue = e.target.value; if (inputValue.length <= 250) { setTempReassignDescription(inputValue); } }}
                                        placeholder="Add notes about the resolution..."
                                        maxLength={250}
                                        style={{
                                          width: "100%", padding: "8px 12px",
                                          border: `2px solid ${tempReassignDescription.length >= 250 ? '#dc3545' : '#3B82F6'}`,
                                          borderRadius: "6px", fontSize: "12px", color: "#374151",
                                          lineHeight: "1.5", resize: "vertical", outline: "none",
                                          fontFamily: "Poppins, sans-serif", boxSizing: "border-box",
                                        }}
                                      />
                                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "4px" }}>
                                        {tempReassignDescription.trim() === '' && <div style={{ color: "#dc3545", fontSize: "11px" }}>Resolved note is required</div>}
                                        <div style={{ marginLeft: "auto", fontSize: "11px", color: tempReassignDescription.length >= 250 ? '#dc3545' : '#6c757d', fontWeight: tempReassignDescription.length >= 250 ? '600' : 'normal' }}>
                                          {tempReassignDescription.length}/250 characters
                                          {tempReassignDescription.length >= 250 && <span style={{ marginLeft: "8px", color: "#dc3545" }}>Character limit reached</span>}
                                        </div>
                                      </div>
                                    </div>
                                  </Modal.Body>
                                  <Modal.Footer style={{ border: "none", padding: "6px 20px 16px 20px" }}>
                                    <div style={{ display: "flex", gap: "10px", width: "100%" }}>
                                      <button
                                        onClick={handleReassignModalClose}
                                        style={{ flex: 1, height: "38px", borderRadius: "6px", fontFamily: "Poppins, sans-serif", fontSize: "13px", fontWeight: "500", color: "#374151", border: "1px solid #D1D5DB", backgroundColor: "#fff", cursor: "pointer" }}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        onClick={() => {
                                          setReassignDescription(tempReassignDescription);
                                          if (tempReassignDescription.trim()) {
                                            setReassignmentPrefix(`[Resolved description] - ${tempReassignDescription}`);
                                            setComment(`[Resolved description] - ${tempReassignDescription}\n\n`);
                                          }
                                          setShowReassignModal(false);
                                        }}
                                        disabled={tempReassignDescription.trim() === '' || tempReassignDescription.length >= 250}
                                        style={{ flex: 1, height: "38px", borderRadius: "6px", backgroundColor: tempReassignDescription.trim() === '' ? "#93C5FD" : "#3B82F6", border: "none", fontFamily: "Poppins, sans-serif", fontSize: "13px", fontWeight: "500", color: "white", cursor: tempReassignDescription.trim() === '' ? "not-allowed" : "pointer" }}
                                      >
                                        Mark Resolved
                                      </button>
                                    </div>
                                  </Modal.Footer>
                                </Modal>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        {(userLevel === "L2" && ticketData?.originalData?.escalateRemarks2) && (
                          <div style={{ padding: "6px 8px" }}>
                            <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Escalation Remarks</p>
                            <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b", padding: "8px 12px", backgroundColor: "#f8f9fa", borderRadius: "8px", minHeight: "47px" }}>{ticketData.originalData.escalateRemarks2}</p>
                          </div>
                        )}
                        {(userLevel === "L3" && ticketData?.originalData?.escalateRemarks3) && (
                          <div style={{ padding: "6px 8px" }}>
                            <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Escalation Remarks</p>
                            <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b", padding: "8px 12px", backgroundColor: "#f8f9fa", borderRadius: "8px", minHeight: "47px" }}>{ticketData.originalData.escalateRemarks3}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {ticketData?.originalData?.oldGrievanceInformationEntity[0]?.reOpenedRemarks && (
                    <div className="row">
                      <div className="col-3" style={{ marginTop: ticketData?.originalData?.grievanceTicketMapEntity?.actionMessage ? "-89px" : !userLevel ? "0px" : "-100px", marginLeft: userLevel === "L1" ? "3px" : "24px" }}>
                        <div style={{ padding: "6px 8px" }}>
                          <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Reopened Date & Time</p>
                          <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b" }}>
                            {formatReopenedDateTime(ticketData.originalData?.oldGrievanceInformationEntity[0]?.reOpenedDateAndTime)}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {ticketData?.originalData?.oldGrievanceInformationEntity[0]?.reOpenedRemarks && (
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "6px", marginBottom: "4px" }}>
                      <div style={{ padding: "6px 8px" }}>
                        <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Reopened Remarks</p>
                        <p className="mb-0" style={{ fontSize: "14px", color: "#1e293b" }}>
                          {ticketData.originalData?.oldGrievanceInformationEntity[0]?.reOpenedRemarks}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              )}
            </div>

            {/* Assignment Transfer History for HO Users */}
            {isAdmin && ticketData?.originalData?.grievanceReassignmentL1Entities && ticketData.originalData.grievanceReassignmentL1Entities.length > 0 && (
              <div className="mb-3" style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)", border: "1px solid #e2e8f0", overflow: "hidden" }}>
                <div style={{ padding: "9px 18px", color: "#2E6DA4", backgroundColor: "#EBF4FA", borderBottom: "1px solid #EEF1F5" }}>
                  <h6 style={{ fontSize: "15px", fontWeight: "600", margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="bi bi-arrow-left-right" style={{ fontSize: "15px" }}></i>
                    Assignment Transfer History
                  </h6>
                </div>
                <div style={{ padding: "10px 14px", marginTop: "6px" }}>
                  <div style={{ overflowX: "auto" }}>
                    <table className="table table-hover" style={{ width: "100%", borderCollapse: "separate", borderSpacing: "0", fontSize: "14px" }}>
                      <thead>
                        <tr style={{ backgroundColor: "#f8fafc" }}>
                          {["S.No", "Previous Assigned User", "New Assigned User", "Resolved Description", "Status", "Reassigned Date & Time"].map((h, i) => (
                            <th key={i} style={{ padding: "12px 16px", fontWeight: "600", color: "#ffffff", fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "2px solid #2E6DA4", verticalAlign: "middle", backgroundColor: "#2E6DA4", borderTopLeftRadius: i === 0 ? "8px" : undefined, borderTopRightRadius: i === 5 ? "8px" : undefined }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {ticketData.originalData.grievanceReassignmentL1Entities.map((reassignment, index) => {
                          const statusMap = { 837: "Open", 838: "In Progress", 840: "Resolved", 841: "Closed", 842: "Rejected", 850: "Issue Pending at User Level", 851: "Issue Pending at External Vendor" };
                          return (
                            <tr key={reassignment.id || index} style={{ borderBottom: "1px solid #e2e8f0" }}>
                              <td style={{ padding: "12px 16px", color: "#1e293b", fontWeight: "500", verticalAlign: "middle" }}>{index + 1}</td>
                              <td style={{ padding: "12px 16px", color: "#1e293b", fontWeight: "500", verticalAlign: "middle" }}>{reassignment?.previousL1UserName || "N/A"}</td>
                              <td style={{ padding: "12px 16px", color: "#1e293b", fontWeight: "500", verticalAlign: "middle" }}>{reassignment?.newL1UserName || "N/A"}</td>
                              <td style={{ padding: "12px 16px", color: "#1e293b", maxWidth: "250px", verticalAlign: "middle" }}>
                                {reassignment.reassignmentDescription ? <span style={{ maxWidth: "230px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "inline-block" }} title={reassignment.reassignmentDescription}>{reassignment.reassignmentDescription}</span> : <span style={{ color: "#94a3b8" }}>N/A</span>}
                              </td>
                              <td style={{ padding: "12px 16px", color: "#1e293b", verticalAlign: "middle" }}>
                                {reassignment.grievanceStatus ? (
                                  <span style={{ padding: "4px 12px", borderRadius: "6px", fontSize: "12px", fontWeight: "600", display: "inline-block", backgroundColor: reassignment.grievanceStatus === 841 ? "#E0E8F9" : reassignment.grievanceStatus === 840 ? "#E2F0CB" : reassignment.grievanceStatus === 838 ? "#FFF1E6" : reassignment.grievanceStatus === 837 ? "#FDE2E4" : reassignment.grievanceStatus === 842 ? "#FBE3E8" : "#F3F4F6", color: reassignment.grievanceStatus === 841 ? "#304FFE" : reassignment.grievanceStatus === 840 ? "#228B22" : reassignment.grievanceStatus === 838 ? "#FF7F11" : reassignment.grievanceStatus === 837 ? "#D90429" : reassignment.grievanceStatus === 842 ? "#B00020" : "#6B7280" }}>
                                    {statusMap[reassignment.grievanceStatus] || "Unknown"}
                                  </span>
                                ) : <span style={{ color: "#94a3b8" }}>N/A</span>}
                              </td>
                              <td style={{ padding: "12px 16px", color: "#1e293b", verticalAlign: "middle" }}>
                                {reassignment.reassignedAt ? (() => { const d = new Date(reassignment.reassignedAt); const day = String(d.getDate()).padStart(2, "0"); const month = String(d.getMonth() + 1).padStart(2, "0"); const year = d.getFullYear(); let hours = d.getHours(); const minutes = String(d.getMinutes()).padStart(2, "0"); const ampm = hours >= 12 ? "PM" : "AM"; hours = hours % 12 || 12; return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`; })() : <span style={{ color: "#94a3b8" }}>N/A</span>}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* L2 Assignment Transfer History */}
            {supportAdmin && ticketData?.originalData?.grievanceReassignmentL2Entities && ticketData.originalData.grievanceReassignmentL2Entities.length > 0 && (
              <div className="mb-3" style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)", border: "1px solid #e2e8f0", overflow: "hidden" }}>
                <div style={{ padding: "9px 18px", color: "#2E6DA4", backgroundColor: "#EBF4FA", borderBottom: "1px solid #EEF1F5" }}>
                  <h6 style={{ fontSize: "15px", fontWeight: "600", margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="bi bi-arrow-left-right" style={{ fontSize: "15px" }}></i>
                    L2 Assignment Transfer History
                  </h6>
                </div>
                <div style={{ padding: "10px 14px", marginTop: "6px" }}>
                  <div style={{ overflowX: "auto" }}>
                    <table className="table table-hover" style={{ width: "100%", borderCollapse: "separate", borderSpacing: "0", fontSize: "14px" }}>
                      <thead>
                        <tr>
                          {["S.No", "Previous L2 User", "New L2 User", "Resolved Description", "Status", "Reassigned Date & Time"].map((h, i) => (
                            <th key={i} style={{ padding: "12px 16px", fontWeight: "600", color: "#ffffff", fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "2px solid #2E6DA4", verticalAlign: "middle", backgroundColor: "#2E6DA4", borderTopLeftRadius: i === 0 ? "8px" : undefined, borderTopRightRadius: i === 5 ? "8px" : undefined }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {ticketData.originalData.grievanceReassignmentL2Entities.map((reassignment, index) => {
                          const statusMap = { 837: "Open", 838: "In Progress", 840: "Resolved", 841: "Closed", 842: "Rejected", 850: "Issue Pending at User Level", 851: "Issue Pending at External Vendor" };
                          return (
                            <tr key={reassignment.id || index} style={{ borderBottom: "1px solid #e2e8f0" }}>
                              <td style={{ padding: "12px 16px", color: "#1e293b", fontWeight: "500", verticalAlign: "middle" }}>{index + 1}</td>
                              <td style={{ padding: "12px 16px", color: "#1e293b", fontWeight: "500", verticalAlign: "middle" }}>{reassignment?.previousL2UserName || "N/A"}</td>
                              <td style={{ padding: "12px 16px", color: "#1e293b", fontWeight: "500", verticalAlign: "middle" }}>{reassignment?.newL2UserName || "N/A"}</td>
                              <td style={{ padding: "12px 16px", color: "#1e293b", maxWidth: "250px", verticalAlign: "middle" }}>
                                {reassignment.reassignmentDescription ? <span style={{ maxWidth: "230px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "inline-block" }} title={reassignment.reassignmentDescription}>{reassignment.reassignmentDescription}</span> : <span style={{ color: "#94a3b8" }}>N/A</span>}
                              </td>
                              <td style={{ padding: "12px 16px", color: "#1e293b", verticalAlign: "middle" }}>
                                {reassignment.grievanceStatus ? (
                                  <span style={{ padding: "4px 12px", borderRadius: "6px", fontSize: "12px", fontWeight: "600", display: "inline-block", backgroundColor: reassignment.grievanceStatus === 841 ? "#E0E8F9" : reassignment.grievanceStatus === 840 ? "#E2F0CB" : reassignment.grievanceStatus === 838 ? "#FFF1E6" : reassignment.grievanceStatus === 837 ? "#FDE2E4" : reassignment.grievanceStatus === 842 ? "#FBE3E8" : "#F3F4F6", color: reassignment.grievanceStatus === 841 ? "#304FFE" : reassignment.grievanceStatus === 840 ? "#228B22" : reassignment.grievanceStatus === 838 ? "#FF7F11" : reassignment.grievanceStatus === 837 ? "#D90429" : reassignment.grievanceStatus === 842 ? "#B00020" : "#6B7280" }}>
                                    {statusMap[reassignment.grievanceStatus] || "Unknown"}
                                  </span>
                                ) : <span style={{ color: "#94a3b8" }}>N/A</span>}
                              </td>
                              <td style={{ padding: "12px 16px", color: "#1e293b", verticalAlign: "middle" }}>
                                {reassignment.reassignedAt ? (() => { const d = new Date(reassignment.reassignedAt); const day = String(d.getDate()).padStart(2, "0"); const month = String(d.getMonth() + 1).padStart(2, "0"); const year = d.getFullYear(); let hours = d.getHours(); const minutes = String(d.getMinutes()).padStart(2, "0"); const ampm = hours >= 12 ? "PM" : "AM"; hours = hours % 12 || 12; return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`; })() : <span style={{ color: "#94a3b8" }}>N/A</span>}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {showTransferReasonModal && (
              <div className="modal" style={{ display: "block", position: "fixed", zIndex: 1050, left: 0, top: 0, width: "100%", height: "100%", overflow: "auto", backgroundColor: "rgba(0,0,0,0.4)" }} onClick={closeTransferReasonModal}>
                <div className="modal-dialog modal-lg" style={{ position: "relative", width: "auto", margin: "1.75rem auto", maxWidth: "600px" }} onClick={(e) => e.stopPropagation()}>
                  <div className="modal-content" style={{ position: "relative", display: "flex", flexDirection: "column", width: "100%", backgroundColor: "#fff", backgroundClip: "padding-box", border: "1px solid rgba(0,0,0,.2)", borderRadius: "0.3rem", boxShadow: "0 0.25rem 0.5rem rgba(0,0,0,.5)" }}>
                    <div className="modal-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "1rem 1rem", borderBottom: "1px solid #dee2e6", borderTopLeftRadius: "0.3rem", borderTopRightRadius: "0.3rem" }}>
                      <h5 className="modal-title" style={{ margin: 0, lineHeight: 1.5, fontFamily: "Poppins", fontWeight: 600, fontSize: "16px" }}>Transfer Reason</h5>
                      <button type="button" className="btn-close" onClick={closeTransferReasonModal} style={{ padding: 0, background: "none", border: 0, fontSize: "1.5rem", fontWeight: 700, lineHeight: 1, color: "#000", textShadow: "0 1px 0 #fff", opacity: 0.5, cursor: "pointer" }}>×</button>
                    </div>
                    <div className="modal-body" style={{ position: "relative", flex: "1 1 auto", padding: "1rem", fontFamily: "Poppins", fontSize: "14px", lineHeight: "1.6", wordWrap: "break-word", maxHeight: "400px", overflowY: "auto" }}>{selectedTransferReason}</div>
                    <div className="modal-footer" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: "0.75rem", borderTop: "1px solid #dee2e6", borderBottomRightRadius: "0.3rem", borderBottomLeftRadius: "0.3rem" }}>
                      <button type="button" className="btn btn-secondary" onClick={closeTransferReasonModal} style={{ backgroundColor: "#6c757d", borderColor: "#6c757d", color: "#fff", padding: "0.375rem 0.75rem", fontSize: "0.875rem", lineHeight: 1.5, borderRadius: "0.25rem", border: "1px solid transparent", cursor: "pointer", fontFamily: "Poppins" }}>Close</button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Requestor Information Card */}
            <div className="mb-3" style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)", border: "1px solid #e2e8f0", overflow: "hidden" }}>
              <div style={{ padding: "9px 18px", color: "#2E6DA4", backgroundColor: "#EBF4FA", borderBottom: "1px solid #EEF1F5" }}>
                <h6 style={{ fontSize: "15px", fontWeight: "600", margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
                  <i className="bi bi-person-circle" style={{ fontSize: "15px" }}></i>
                  Requestor Information
                </h6>
              </div>

              <div style={{ padding: "10px 14px" }}>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "6px", marginBottom: "2px" }}>
                  <div style={{ padding: "6px 8px" }}>
                    <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Requestor User ID</p>
                    <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b" }}>{displayData(ticketData?.customerName)}</p>
                  </div>
                  <div style={{ padding: "6px 8px" }}>
                    <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Requestor Contact Number</p>
                    <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b" }}>{displayData(ticketData?.phoneNumber)}</p>
                  </div>
                  <div style={{ padding: "6px 8px" }}>
                    <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Requestor Email Address</p>
                    <p className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b" }}>{displayData(ticketData?.email)}</p>
                  </div>
                  <div style={{ padding: "6px 8px" }}>
                    <p className="mb-1" style={{ color: "#98A2B3", fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>Preferred Resolution Method</p>
                    <div className="mb-0" style={{ fontWeight: "500", fontSize: "14px", color: "#1e293b" }}>{displayData(ticketData?.resolutionMethod)}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Attached Media Card */}
            <div className="mb-3" style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)", border: "1px solid #e2e8f0", overflow: "hidden" }}>
              <div style={{ padding: "9px 18px", color: "#2E6DA4", backgroundColor: "#EBF4FA", borderBottom: "1px solid #EEF1F5" }}>
                <h6 style={{ fontSize: "14px", fontWeight: "600", margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
                  <i className="bi bi-images" style={{ fontSize: "14px" }}></i>
                  Attached Media
                </h6>
              </div>

              <div style={{ padding: "10px 14px" }}>
                {mediaList.length > 0 ? (
                  <div>
                    <div className="d-flex position-relative" style={{ marginBottom: "20px", gap: "16px", overflowX: "auto", paddingBottom: "10px" }}>
                      {mediaList.map((media, index) => {
                        const isPdf = isPdfFile(media.mediaPath);
                        const isVideo = isVideoFile(media.mediaPath);

                        return (
                          <div key={media.id || index} style={{ display: "flex", flexDirection: "column", alignItems: "center", flexShrink: 0, width: "100px" }}>
                            <div
                              className="position-relative"
                              style={{ width: "100px", height: "100px", borderRadius: "10px", overflow: "hidden", cursor: "pointer", border: index === currentImageIndex ? "3px solid #2E6DA4" : "1px solid #e2e8f0", marginBottom: "8px" }}
                              onClick={() => handleMediaClick(media, index)}
                              onMouseEnter={(e) => { if (index !== currentImageIndex) { e.currentTarget.style.transform = "scale(1.02)"; e.currentTarget.style.boxShadow = "0 8px 25px -5px rgba(0, 0, 0, 0.25)"; } }}
                              onMouseLeave={(e) => { if (index !== currentImageIndex) { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0, 0, 0, 0.1)"; } }}
                            >
                              {isPdf ? (
                                <div style={{ width: "100%", height: "100%", background: "linear-gradient(135deg, #fee2e2, #fecaca)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", opacity: index === currentImageIndex ? 1 : 0.8 }}>
                                  <i className="bi bi-file-earmark-pdf text-danger" style={{ fontSize: "32px" }}></i>
                                  <small className="text-danger mt-2 fw-bold">PDF</small>
                                </div>
                              ) : isVideo ? (
                                <div style={{ position: "relative", width: "100%", height: "100%" }}>
                                  <video style={{ width: "100%", height: "100%", objectFit: "cover", opacity: index === currentImageIndex ? 1 : 0.8 }} muted preload="metadata">
                                    <source src={media.mediaPath} type="video/mp4" />
                                  </video>
                                  <i className="bi bi-play-circle-fill" style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", fontSize: "28px", color: "#ffffff", textShadow: "0 1px 4px rgba(0,0,0,0.6)", pointerEvents: "none" }}></i>
                                </div>
                              ) : (
                                <img src={media.mediaPath} alt={media.fileName || `Media ${index + 1}`} style={{ width: "100%", height: "100%", objectFit: "cover", opacity: index === currentImageIndex ? 1 : 0.8 }} onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }} />
                              )}
                              <div style={{ display: "none", width: "100%", height: "100%", background: "linear-gradient(135deg, #f3f4f6, #e5e7eb)", alignItems: "center", justifyContent: "center", color: "#6b7280", fontSize: "12px", textAlign: "center" }}>
                                <div><i className="bi bi-image" style={{ fontSize: "24px", marginBottom: "8px" }}></i><div>Image not found</div></div>
                              </div>
                            </div>
                            {media.fileName && (
                              <div style={{ fontSize: "11px", color: "#6b7280", textAlign: "center", fontWeight: "500", width: "100px", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", padding: "0 4px" }} title={getFileNameWithoutExtension(media.fileName)}>
                                {getFileNameWithoutExtension(media.fileName)}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-2" style={{ background: "linear-gradient(135deg, #f8fafc, #f1f5f9)", borderRadius: "12px", border: "2px dashed #cbd5e1" }}>
                    <i className="bi bi-image text-muted" style={{ fontSize: "25px" }}></i>
                    <p className="text-muted mt-1 mb-0" style={{ fontSize: "14px", fontWeight: "500" }}>No attachments available</p>
                  </div>
                )}
              </div>
            </div>

            <MediaModal />
            {renderAttachmentsSection()}
            {renderCommentsSection()}
            {renderSubmitButtons()}
          </div>
        </div>
        <UserTooltip />
        {showReopenModal && (
          <ReopenModal
            show={showReopenModal}
            onClose={() => setShowReopenModal(false)}
            ticketData={ticketData}
            userId={user}
            onReopen={handleReopenSubmit}
            reopenRemarks={reopenRemarks}
            setReopenRemarks={setReopenRemarks}
            reopenFiles={reopenFiles}
            setReopenFiles={setReopenFiles}
            reopenToUserId={reopenToUserId}
            setReopenToUserId={setReopenToUserId}
            isSubmitting={isSubmittingReopen}
            userProfile={userProfile}
            l1Users={crossDepartmentLOUsers}
          />
        )}
      </div>
      </div>
    );
  };

  return renderTicketView();
};

export default ViewRaisedTicket;